import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RawCalcTrainDataViewModel } from 'src/app/models/OpRawCalc.model';
import { Stage } from 'src/app/models/role.model';
import { Train } from 'src/app/models/train.model';
import { OpdataService } from 'src/app/services/opdata/opdata.service';
import { TrainService } from 'src/app/services/trains/trains.service';
import { PlotlyService } from '../plotly.service';
import { PlantsService } from 'src/app/services/plants/plants.service';
import { Plant } from 'src/app/models/plant.model';
import { AllTrainData, CustomGraphConfigData } from './comparasiongraph.model';
import html2canvas from 'html2canvas';
@Component({
  selector: 'app-comparasiongraph',
  templateUrl: './comparasiongraph.component.html',
  styleUrls: ['./comparasiongraph.component.scss'],
})
export class ComparasiongraphComponent {
  @ViewChild('captureArea', { static: false }) captureArea: ElementRef;
  public WindowRef : Window;
  NewWidth: any;
  field1: string = '0';
  field1Name: string = '';
  projectNo: string = '0';
  fieldDDl = [];
  tempField: string = '';
  plants: Plant[] = [];
  SelectedId: string = '';
  allTrainList: Train[] = [];
  selectedNoOfProject: number[] = [];
  selectedConfigDataList: CustomGraphConfigData[] = [];
  selectedTrainIds: string = '';
  opCalData: AllTrainData = new AllTrainData();

  plantName: string = '';
  trainDetails: Train = new Train();
  trainId: string = '';
  plantId: string = '';
  graphName: string = '';
  graphName2: string = '';
  graphName3: string = '';
  checkOriginalStage: boolean = false;
  trainStage: number;
  project1trainStage: number = 1;
  project2trainStage: number = 1;
  project3trainStage: number = 1;
  project4trainStage: number = 1;
  project5trainStage: number = 1;

  project1trainUnit: number;
  project2trainUnit: number;
  project3trainUnit: number;
  project4trainUnit: number;
  project5trainUnit: number;

  title: string = '';
  trainIdNew: any = '';
  project1Name: string = '';
  project2Name: string = '';
  project3Name: string = '';
  project4Name: string = '';
  project5Name: string = '';

  project1TrainName: string = '';
  project2TrainName: string = '';
  project3TrainName: string = '';
  project4TrainName: string = '';
  project5TrainName: string = '';

  project1PlantName: string = '';
  project2PlantName: string = '';
  project3PlantName: string = '';
  project4PlantName: string = '';
  project5PlantName: string = '';

  project1Stage: number = 1;
  project2Stage: number = 1;
  project3Stage: number = 1;
  project4Stage: number = 1;
  project5Stage: number = 1;

  project1StageTemp: number = 0;
  project2StageTemp: number = 0;
  project3StageTemp: number = 0;
  project4StageTemp: number = 0;
  project5StageTemp: number = 0;

  loggedInUserRole:string;
  loggedinUserId:string;
  plantAndUserId:string;
  selectedPlantFromBreadcrumb: number | null = null;
  selectedTrainFromBreadcrumb: number | null = null;

  downloadbtn: boolean = false;
  chkIfTotal=false;

  public projectNoList: Array<Stage> = [
    { Id: 2, Name: '2' },
    { Id: 3, Name: '3' },
    { Id: 4, Name: '4' },
    { Id: 5, Name: '5' },
  ];

  public stage3: Array<Stage> = [
    { Id: 1, Name: 'Total' },
    { Id: 2, Name: '1' },
    { Id: 3, Name: '2' },
    { Id: 4, Name: '3' },
  ];
  public stage2: Array<Stage> = [
    { Id: 1, Name: 'Total' },
    { Id: 2, Name: '1' },
    { Id: 3, Name: '2' },
  ];

  public stageTotal: Array<Stage> = [{ Id: 1, Name: 'Total' }];
  

  stageselected: any;

  
  UDFieldList = [
    'User Defined 1',
    'User Defined 2',
    'User Defined 3',
    'User Defined 4',
    'User Defined 5',
  ];
  UDSelected: boolean = true;

  constructor(
    private plantService: PlantsService,
    private plot: PlotlyService,
    private trainService: TrainService,
    private route: ActivatedRoute,
    private opdataService: OpdataService
  ) {
    this.route.queryParams.subscribe((params) => {
      this.trainId = params['trainId'];
      this.plantId = params['plantId'];
      this.plantName = params['plantName'];
    });
  }

  ngOnInit(): void {
    this.WindowRef = window;
    console.log(this.WindowRef.innerWidth);
    this.NewWidth = 1500;
    if (this.WindowRef.innerWidth > 1500) {
      this.NewWidth = this.WindowRef.innerWidth;
    }
    const currentUser = sessionStorage.getItem('currentUser');
    if (currentUser) {
      const parsed = JSON.parse(atob(currentUser));
      this.loggedInUserRole = parsed.role;
      this.loggedinUserId = parsed.userId;
    }
    this.fieldDDl = [
      { value: 'ph', label: 'Feed pH' },
      { value: 'temp', label: 'Feed Temp' },
      { value: 'feed_cond', label: 'Feed Conductivity' },
      { value: 'feed_flow', label: 'Feed Flow' },
      { value: 'feed_press', label: 'Feed Pressure' },
      { value: 'conc_flow', label: 'Concentrate Flow' },
      { value: 'conc_press', label: 'Concentrate Pressure' },
      { value: 'perm_cond', label: 'Permeate Conductivity' },
      { value: 'perm_flow', label: 'Permeate Flow' },
      { value: 'perm_press', label: 'Permeate Pressure' },
      { value: 'recovery', label: 'Recovery' },
      { value: 'flux', label: 'Flux' },
      { value: 'dp', label: 'Differential Pressure' },
      { value: 'tmp', label: 'TMP' },
      { value: 'net_driv_press', label: 'Net Driving Pressure' },
      { value: 'a_val', label: 'A Value' },
      { value: 'b_val', label: 'B Value' },
      { value: 'npf', label: 'Normalized Permeate Flow' },
      { value: 'nsp', label: 'Normalized Salt Passage' },
      { value: 'norm_diff_press', label: 'Normalized Differential Pressure' },
      { value: 'ud1', label: 'User Defined 1' },
      { value: 'ud2', label: 'User Defined 2' },
      { value: 'ud3', label: 'User Defined 3' },
      { value: 'ud4', label: 'User Defined 4' },
      { value: 'ud5', label: 'User Defined 5' },
    ];
    this.getPlants();

    this.plantService.selectedPlant$.subscribe((plantId) => {
      if (plantId) {
        this.selectedPlantFromBreadcrumb = plantId;
        this.applyBreadcrumbSelection();
      }
    });

    this.plantService.selectedTrain$.subscribe((trainId) => {
      if (trainId) {
        this.selectedTrainFromBreadcrumb = trainId;
        this.applyBreadcrumbSelection();
      }
    });

    // Auto-select 2 projects if a plant or train is already present from query params (breadcrumb)
    if (this.plantId || this.trainId) {
      this.projectNo = '2';
      this.onProjectChange(null);
    }
  }
  applyBreadcrumbSelection() {
    if (this.selectedConfigDataList && this.selectedConfigDataList.length > 0) {
      if (this.selectedPlantFromBreadcrumb) {
        const plantId = this.selectedPlantFromBreadcrumb;
        this.selectedConfigDataList[0].plantId = plantId;
        this.getSelectedId({ target: { value: plantId } }, this.selectedConfigDataList[0], 1);
        this.selectedPlantFromBreadcrumb = null;
      }
      if (this.selectedTrainFromBreadcrumb) {
        const trainId = this.selectedTrainFromBreadcrumb;
        this.selectedConfigDataList[0].trainId = trainId;
        this.trainService.getTrainById(trainId.toString()).subscribe({
          next: (response) => {
            this.trainDetails = response;
            this.project1TrainName = response.Name;
            this.project1trainUnit = response.Units;
            this.project1trainStage = response.Stages;
            this.selectedConfigDataList[0].stage = response.Stages;
          }
        });
        this.selectedTrainFromBreadcrumb = null;
      }
    }
  }
  getName(type) {}

  captureScreen() {
    const element = this.captureArea.nativeElement;
    html2canvas(element).then(canvas => {
        const dataUrl = canvas.toDataURL("image/png");
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = 'Comparasion Graph.png';
        link.click();
    });
}

  onOptionSelectedfield_1(event: any) {
    this.field1Name =
      this.fieldDDl[event.target['options'].selectedIndex - 1].label;
    this.tempField = this.fieldDDl[event.target['options'].selectedIndex - 1].label;
    if (this.UDFieldList.includes(this.tempField)) {
      this.UDSelected = false;
    }
    else {
      this.UDSelected = true;
    }
  }

  /* resetOtherConfig(project) {
    this.selectedConfigDataList.forEach((element) => {
      if (element.showSystemConfig != 'Project' + project) {
        element.showSystemConfig = 'No';
      }
    });
  } */

  debugger() {
    console.log(this.selectedConfigDataList);
  }

  showGraph() {
    this.downloadbtn = true;
    if (this.selectedConfigDataList.some((x) => x.plantId == 0)) {
      alert('Select Plant for all Projects');
      return;
    }

    if (this.selectedConfigDataList.some((x) => x.trainId == 0)) {
      alert('Select Train for all Projects');
      return;
    }

   /*  let yesSelection = this.selectedConfigDataList.some((x) =>
      x.showSystemConfig.includes('Project')
    );
    if (!yesSelection) {
      alert('Select Display System Configuration');
      return;
    } */

    this.selectedTrainIds = '';
    this.selectedConfigDataList.forEach((element) => {
      this.selectedTrainIds = this.selectedTrainIds + 'Z' + element.trainId;
    });
    console.log(this.selectedTrainIds);
    this.opdataService

      .GetOPCalcdataNewForComparisonGraph(this.selectedTrainIds)
      .subscribe({
        next: (response) => {
          this.opCalData = response;
          console.log(this.opCalData);
          this.getCalcData();
        },
      });
  }

  getPlants() {
    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if(loggedInuserRole.role =='Standard User')
    {
      this.loggedInUserRole = loggedInuserRole.role;
      this.loggedinUserId = loggedInuserRole.userId;

      this.plantService.getPlantsByUserId(loggedInuserRole.userId)
        .subscribe({
        next: (plants)=>{
            this.plants = plants;
          },
        })

    }
    else
    {
      this.plantService.getAllPlant().subscribe({
        next: (plants) => {
          this.plants = plants;
        },
        error: (response) => {
          console.log(response);
        },
      });
    }
  }

  getTrainById() {
    console.log(this.trainId);
    this.trainService.getTrainById(this.trainId).subscribe({
      next: (response) => {
        this.trainDetails = response;
      },
    });
  }

  onProjectChange(event: any) {

    if (this.selectedConfigDataList.length < +this.projectNo) {
      let diff = +this.projectNo - this.selectedConfigDataList.length;
      for (let i = 1; i <= +diff; i++) {
        let model = new CustomGraphConfigData();
        model.plantId = 0;
        model.trainId = 0;
        model.stage = 1;
        model.unit = 0;
        model.showSystemConfig = 'No';
        model.projectNo = this.selectedConfigDataList.length + 1;
        this.selectedConfigDataList.push(model);
        console.log(this.selectedConfigDataList);
      }
    } else {
      let diff = this.selectedConfigDataList.length - +this.projectNo;

      for (let i = 1; i <= +diff; i++) {
        this.selectedConfigDataList.pop();
        console.log(this.selectedConfigDataList);
      }
    }

    this.applyBreadcrumbSelection();
  }

  onStageChange(e: any, model: CustomGraphConfigData, projectNo) {
    this.stageselected = +e.target.value-1;
    
    if (+projectNo == 1) 
      {
      this.project1Stage = this.stageselected;
      if(this.stageselected==0)
      {
        this.chkIfTotal=true;
      }
      else
      {
      this.selectedConfigDataList[0].stage = this.stageselected;
      }
      this.checkOriginalStage = true;

    } 
    else if (+projectNo == 2) {
      this.project2Stage = this.stageselected;
      this.selectedConfigDataList[1].stage = this.stageselected;
    } else if (+projectNo == 3) {
      this.project3Stage = this.stageselected;
      this.selectedConfigDataList[2].stage = this.stageselected;
    } else if (+projectNo == 4) {
      this.project4Stage = this.stageselected;
      this.selectedConfigDataList[3].stage = this.stageselected;
    } else if (+projectNo == 5) {
      this.project5Stage = this.stageselected;
      this.selectedConfigDataList[4].stage = this.stageselected;
    }
  }

  onTrainChange(e: any, model: CustomGraphConfigData, projectNo) {
    const updateTrainNameAndDetails = () => {
      const filtered = model.trainList.filter((x) => x.value == +model.trainId);
      const label = filtered.length > 0 ? filtered[0].label : '';

      if (+projectNo == 1) {
        this.project1TrainName = label;
      } else if (+projectNo == 2) {
        this.project2TrainName = label;
      } else if (+projectNo == 3) {
        this.project3TrainName = label;
      } else if (+projectNo == 4) {
        this.project4TrainName = label;
      } else if (+projectNo == 5) {
        this.project5TrainName = label;
      }

      this.trainIdNew = +model.trainId;
      this.trainService.getTrainById(this.trainIdNew).subscribe({
        next: (response) => {
          this.trainDetails = response;
          if (+projectNo == 1) {
            this.project1trainUnit = this.trainDetails.Units;
            this.project1trainStage = this.trainDetails.Stages;
          } else if (+projectNo == 2) {
            this.project2trainUnit = this.trainDetails.Units;
            this.project2trainStage = this.trainDetails.Stages;
          } else if (+projectNo == 3) {
            this.project3trainUnit = this.trainDetails.Units;
            this.project3trainStage = this.trainDetails.Stages;
          } else if (+projectNo == 4) {
            this.project4trainUnit = this.trainDetails.Units;
            this.project4trainStage = this.trainDetails.Stages;
          } else if (+projectNo == 5) {
            this.project5trainUnit = this.trainDetails.Units;
            this.project5trainStage = this.trainDetails.Stages;
          }
        },
      });
    };

    if (model.trainList && model.trainList.length > 0) {
      updateTrainNameAndDetails();
      const filtered = model.trainList.filter((x) => x.value == +model.trainId);
      if (filtered.length > 0) {
        model.stage = +filtered[0].stages;
      }
    } else {
      this.trainService.getTrainById(model.trainId.toString()).subscribe((res) => {
        if (res) {
          if (+projectNo == 1) {
            this.project1TrainName = res.Name;
            this.project1trainUnit = res.Units;
            this.project1trainStage = res.Stages;
          } else if (+projectNo == 2) {
            this.project2TrainName = res.Name;
            this.project2trainUnit = res.Units;
            this.project2trainStage = res.Stages;
          } else if (+projectNo == 3) {
            this.project3TrainName = res.Name;
            this.project3trainUnit = res.Units;
            this.project3trainStage = res.Stages;
          } else if (+projectNo == 4) {
            this.project4TrainName = res.Name;
            this.project4trainUnit = res.Units;
            this.project4trainStage = res.Stages;
          } else if (+projectNo == 5) {
            this.project5TrainName = res.Name;
            this.project5trainUnit = res.Units;
            this.project5trainStage = res.Stages;
          }
        }
      });
    }
  }

  getSelectedId(e: any, model: CustomGraphConfigData, projectNo) {
    const setPlantName = () => {
      const matched = this.plants.filter((x) => x.Id == +model.plantId);
      if (matched.length > 0) {
        if (+projectNo == 1) this.project1PlantName = matched[0].Name;
        else if (+projectNo == 2) this.project2PlantName = matched[0].Name;
        else if (+projectNo == 3) this.project3PlantName = matched[0].Name;
        else if (+projectNo == 4) this.project4PlantName = matched[0].Name;
        else if (+projectNo == 5) this.project5PlantName = matched[0].Name;
      }
    };

    if (this.plants && this.plants.length > 0) {
      setPlantName();
    } else {
      this.plantService.getPlant(model.plantId.toString()).subscribe((res) => {
        if (res) {
          if (+projectNo == 1) this.project1PlantName = res.Name;
          else if (+projectNo == 2) this.project2PlantName = res.Name;
          else if (+projectNo == 3) this.project3PlantName = res.Name;
          else if (+projectNo == 4) this.project4PlantName = res.Name;
          else if (+projectNo == 5) this.project5PlantName = res.Name;
        }
      });
    }
    if(this.loggedInUserRole =='Standard User')
      {
      this.plantAndUserId = model.plantId + 'Z' + this.loggedinUserId;
      this.trainService.GetAccessibleTrainListByPlantId(this.plantAndUserId)

        .subscribe(
          (response: Train[]) => {
            if (response != null) {
              model.trainList = response.map((entity) => ({
                label: entity.Name,
                value: entity.Id,
                stages: entity.Stages,
                sysConfigStr: entity.Systemconfig,
                unit: entity.Units,
              }));
              // Keep selection if it already exists and is valid
              const currentTrainId = model.trainId;
              if (currentTrainId && currentTrainId != 0) {
                const matchedTrain = response.filter(t => t.Id == currentTrainId);
                if (matchedTrain.length > 0) {
                  if (projectNo == 1) {
                    this.project1TrainName = matchedTrain[0].Name;
                    this.project1trainStage = matchedTrain[0].Stages;
                  } else if (projectNo == 2) {
                    this.project2TrainName = matchedTrain[0].Name;
                    this.project2trainStage = matchedTrain[0].Stages;
                  } else if (projectNo == 3) {
                    this.project3TrainName = matchedTrain[0].Name;
                    this.project3trainStage = matchedTrain[0].Stages;
                  } else if (projectNo == 4) {
                    this.project4TrainName = matchedTrain[0].Name;
                    this.project4trainStage = matchedTrain[0].Stages;
                  } else if (projectNo == 5) {
                    this.project5TrainName = matchedTrain[0].Name;
                    this.project5trainStage = matchedTrain[0].Stages;
                  }
                  return;
                }
              }

              // Otherwise reset selection to 0
              if (projectNo == 1) {
                this.project1TrainName = '';
                this.selectedConfigDataList[0].trainId = 0;
                this.project1trainStage = 1;
              } else if (projectNo == 2) {
                this.project2TrainName = '';
                this.selectedConfigDataList[1].trainId = 0;
                this.project2trainStage = 1;
              } else if (projectNo == 3) {
                this.project3TrainName = '';
                this.selectedConfigDataList[2].trainId = 0;
                this.project3trainStage = 1;
              } else if (projectNo == 4) {
                this.project4TrainName = '';
                this.selectedConfigDataList[3].trainId = 0;
                this.project4trainStage = 1;
              } else if (projectNo == 5) {
                this.project5TrainName = '';
                this.selectedConfigDataList[4].trainId = 0;
                this.project5trainStage = 1;
              }
            }
          },

          (error: any) => {
            console.log('error list');
          }
        );
    }
  else
  {
      this.trainService
        .getTrainByPlantIdForGraph(model.plantId.toString())
        .subscribe(
          (response: Train[]) => {
            if (response != null) {
              model.trainList = response.map((entity) => ({
                label: entity.Name,
                value: entity.Id,
                stages: entity.Stages,
                sysConfigStr: entity.Systemconfig,
                unit: entity.Units,
              }));
              // Keep selection if it already exists and is valid
              const currentTrainId = model.trainId;
              if (currentTrainId && currentTrainId != 0) {
                const matchedTrain = response.filter(t => t.Id == currentTrainId);
                if (matchedTrain.length > 0) {
                  if (projectNo == 1) {
                    this.project1TrainName = matchedTrain[0].Name;
                    this.project1trainStage = matchedTrain[0].Stages;
                  } else if (projectNo == 2) {
                    this.project2TrainName = matchedTrain[0].Name;
                    this.project2trainStage = matchedTrain[0].Stages;
                  } else if (projectNo == 3) {
                    this.project3TrainName = matchedTrain[0].Name;
                    this.project3trainStage = matchedTrain[0].Stages;
                  } else if (projectNo == 4) {
                    this.project4TrainName = matchedTrain[0].Name;
                    this.project4trainStage = matchedTrain[0].Stages;
                  } else if (projectNo == 5) {
                    this.project5TrainName = matchedTrain[0].Name;
                    this.project5trainStage = matchedTrain[0].Stages;
                  }
                  return;
                }
              }

              // Otherwise reset selection to 0
              if (projectNo == 1) {
                this.project1TrainName = '';
                this.selectedConfigDataList[0].trainId = 0;
                this.project1trainStage = 1;
              } else if (projectNo == 2) {
                this.project2TrainName = '';
                this.selectedConfigDataList[1].trainId = 0;
                this.project2trainStage = 1;
              } else if (projectNo == 3) {
                this.project3TrainName = '';
                this.selectedConfigDataList[2].trainId = 0;
                this.project3trainStage = 1;
              } else if (projectNo == 4) {
                this.project4TrainName = '';
                this.selectedConfigDataList[3].trainId = 0;
                this.project4trainStage = 1;
              } else if (projectNo == 5) {
                this.project5TrainName = '';
                this.selectedConfigDataList[4].trainId = 0;
                this.project5trainStage = 1;
              }
            }
          },

          (error: any) => {
            console.log('error list');
          }
        );
    }
  }

  GetStatesForDDL(stage: number) {
    if (stage === 1) {
      return [{ Id: 1, Name: 'Total' }];
    } else if (stage === 2) {
      return [
        { Id: 1, Name: 'Total' },
        { Id: 2, Name: '1' },
        { Id: 3, Name: '2' },
      ];
    } else if (stage === 3) {
      return [
        { Id: 1, Name: 'Total' },
        { Id: 2, Name: '1' },
        { Id: 3, Name: '2' },
        { Id: 4, Name: '3' },
      ];
    } else {
      return [];
    }
  }


  getCalcData() {
    if (this.field1 == undefined) {
      alert('Select field name.');
      return;
    } else if (this.projectNo == '') {
      alert('Select # of Project.');
      return;
    } else {
      let x: Date[] = [];
      //adding below variables to hold data for each individual project's  x axis(date time stamp)
      let x2: Date[] = [];
      let x3: Date[] = [];
      let x4: Date[] = [];
      let x5: Date[] = [];
      //

      let y: number[] = [];
      let y1: number[] = [];
      let y2: number[] = [];
      let y3: number[] = [];
      let y4: number[] = [];
      let yname: string = '';
      let y1name: string = '';
      let y2name: string = '';
      let y3name: string = '';
      let y4name: string = '';
      let yaxisname = this.fieldDDl.filter((x) => x.value == this.field1)[0]
        .label;


      this.selectedConfigDataList.forEach((elementSelected) => {
        if (this.field1 != '') {

          if (elementSelected.projectNo == 1) {
            if (elementSelected.showSystemConfig == 'Project1') {
              this.title = elementSelected.trainList.filter(
                (x) => x.value == +elementSelected.trainId
              )[0].sysConfigStr;
            }
            //P1
            this.opCalData.List1.forEach((element) => {
              x.push(new Date(element.Datetime));
              switch (this.field1) {
                case 'temp': {
                  y.push(element.Temp);
                  break;
                }
                case 'ph': {
                  {
                    y.push(element.Ph);
                  }

                  break;
                }
                case 'feed_cond': {
                  if (elementSelected.stage == 1) {
                    y.push(element.S1FeedCond);
                  } else if (elementSelected.stage == 2) {
                    y.push(element.S1FeedCond);
                  } else if (elementSelected.stage == 3) {
                    y.push(element.S2FeedCond);
                  } else {
                    y.push(element.S3FeedCond);
                  }
                  break;
                }
                case 'feed_flow': {
                  if (elementSelected.stage == 1) {
                    y.push(element.TotalFeedFlow);
                  } else if (elementSelected.stage == 2) {
                    y.push(element.S1FeedFlow);
                  } else if (elementSelected.stage == 3) {
                    y.push(element.S2FeedFlow);
                  } else {
                    y.push(element.S3FeedFlow);
                  }
                  break;
                }
                case 'feed_press': {
                  if (elementSelected.stage == 1) {
                    y.push(element.S1FeedPress);
                  } else if (elementSelected.stage == 2) {
                    y.push(element.S1FeedPress);
                  } else if (elementSelected.stage == 3) {
                    y.push(element.S2FeedPress);
                  } else {
                    y.push(element.S3FeedPress);
                  }
                  break;
                }
                case 'conc_flow': {
                  if (elementSelected.stage == 1) {
                    y.push(element.TotalConcFlow);
                  } else if (elementSelected.stage == 2) {
                    y.push(element.S1ConcFlow);
                  } else if (elementSelected.stage == 3) {
                    y.push(element.S2ConcFlow);
                  } else {
                    y.push(element.S3ConcFlow);
                  }
                  break;
                }
                case 'conc_press': {
                  if (elementSelected.stage == 1) {
                    y.push(element.S1ConcPress);
                  } else if (elementSelected.stage == 2) {
                    y.push(element.S1ConcPress);
                  } else if (elementSelected.stage == 3) {
                    y.push(element.S2ConcPress);
                  } else {
                    y.push(element.S3ConcPress);
                  }
                  break;
                }
                case 'perm_cond': {
                  if (elementSelected.stage == 1) {
                    y.push(element.TotalPermCond);
                  } else if (elementSelected.stage == 2) {
                    y.push(element.S1PermCond);
                  } else if (elementSelected.stage == 3) {
                    y.push(element.S2PermCond);
                  } else {
                    y.push(element.S3PermCond);
                  }
                  break;
                }
                case 'perm_flow': {
                  if (elementSelected.stage == 1) {
                    y.push(element.TotalPermFlow);
                  } else if (elementSelected.stage == 2) {
                    y.push(element.S1PermFlow);
                  } else if (elementSelected.stage == 3) {
                    y.push(element.S2PermFlow);
                  } else {
                    y.push(element.S3PermFlow);
                  }
                  break;
                }
                case 'perm_press': {
                  if (elementSelected.stage == 1) {
                    y.push(element.S1PermPress);
                  } else if (elementSelected.stage == 2) {
                    y.push(element.S1PermPress);
                  } else if (elementSelected.stage == 3) {
                    y.push(element.S2PermPress);
                  } else {
                    y.push(element.S3PermPress);
                  }
                  break;
                }
                case 'recovery': {
                  if (elementSelected.stage == 1) {
                    y.push(element.TotalRecovery * 100);
                  } else if (elementSelected.stage == 2) {
                    y.push(element.S1Recovery * 100);
                  } else if (elementSelected.stage == 3) {
                    y.push(element.S2Recovery * 100);
                  } else {
                    y.push(element.S3Recovery);
                  }
                  break;
                }
                case 'flux': {
                  if (elementSelected.stage == 1) {
                    y.push(element.TotalFlux);
                  } else if (elementSelected.stage == 2) {
                    y.push(element.S2Flux);
                  } else if (elementSelected.stage == 3) {
                    y.push(element.S3Flux);
                  } else {
                    y.push(element.TotalFlux);
                  }
                  break;
                }
                case 'dp': {
                  if (elementSelected.stage == 1) {
                    y.push(element.TotalDiffPressure);
                  } else if (elementSelected.stage == 2) {
                    y.push(element.S1DiffPressure);
                  } else if (elementSelected.stage == 3) {
                    y.push(element.S2DiffPressure);
                  } else {
                    y.push(element.S3DiffPressure);
                  }
                  break;
                }
                case 'tmp': {
                  if (elementSelected.stage == 1) {
                    y.push(element.TotalTmp);
                  } else if (elementSelected.stage == 2) {
                    y.push(element.S1Tmp);
                  } else if (elementSelected.stage == 3) {
                    y.push(element.S2Tmp);
                  } else {
                    y.push(element.S3Tmp);
                  }
                  break;
                }
                case 'net_driv_press': {
                  if (elementSelected.stage == 1) {
                    y.push(element.TotalNetDrivPress);
                  } else if (elementSelected.stage == 2) {
                    y.push(element.S1NetDrivPress);
                  } else if (elementSelected.stage == 3) {
                    y.push(element.S2NetDrivPress);
                  } else {
                    y.push(element.S3NetDrivPress);
                  }
                  break;
                }
                case 'a_val': {
                  if (elementSelected.stage == 1) {
                    y.push(element.TotalAVal);
                  } else if (elementSelected.stage == 2) {
                    y.push(element.S1AVal);
                  } else if (elementSelected.stage == 3) {
                    y.push(element.S2AVal);
                  } else {
                    y.push(element.S3AVal);
                  }
                  break;
                }
                case 'b_val': {
                  if (elementSelected.stage == 1) {
                    y.push(element.TotalBVal);
                  } else if (elementSelected.stage == 2) {
                    y.push(element.S1BVal);
                  } else if (elementSelected.stage == 3) {
                    y.push(element.S2BVal);
                  } else {
                    y.push(element.S3BVal);
                  }
                  break;
                }
                case 'npf': {
                  if (elementSelected.stage == 1) {
                    y.push(element.TotalNpf);
                  } else if (elementSelected.stage == 2) {
                    y.push(element.S1Npf);
                  } else if (elementSelected.stage == 3) {
                    y.push(element.S2Npf);
                  } else {
                    y.push(element.S3Npf);
                  }
                  break;
                }
                case 'nsp': {
                  if (elementSelected.stage == 1) {
                    y.push(element.TotalNsp * 100);
                  } else if (elementSelected.stage == 2) {
                    y.push(element.S1Nsp * 100);
                  } else if (elementSelected.stage == 3) {
                    y.push(element.S2Nsp * 100);
                  } else {
                    y.push(element.S3Nsp * 100);
                  }
                  break;
                }
                case 'ud1': {
                  y.push(element.Ud1);
                  break;
                }
                case 'ud2': {
                  y.push(element.Ud2);
                  break;
                }
                case 'ud3': {
                  y.push(element.Ud3);
                  break;
                }
                case 'ud4': {
                  y.push(element.Ud4);
                  break;
                }
                case 'ud5': {
                  y.push(element.Ud5);
                  break;
                }
                case 'norm_diff_press': {
                  if (elementSelected.stage == 1) {
                    y.push(element.TotalNormDiffPress);
                  } else if (elementSelected.stage == 2) {
                    y.push(element.S1NormDiffPress);
                  } else if (elementSelected.stage == 3) {
                    y.push(element.S2NormDiffPress);
                  } else {
                    y.push(element.S3NormDiffPress);
                  }
                  break;
                }
                default: {
                  //statements;
                  break;
                }
              }
            });
          } else if (elementSelected.projectNo == 2) {
            if (elementSelected.showSystemConfig == 'Project2') {
              this.title = elementSelected.trainList.filter(
                (x) => x.value == +elementSelected.trainId
              )[0].sysConfigStr;
            }

            //P2
            this.opCalData.List2.forEach((element) => {
              x2.push(new Date(element.Datetime));
              switch (this.field1) {
                case 'temp': {
                  y1.push(element.Temp);
                  break;
                }
                case 'ph': {
                  {
                    y1.push(element.Ph);
                  }

                  break;
                }
                case 'feed_cond': {
                  if (elementSelected.stage == 1) {
                    y1.push(element.S1FeedCond);
                  } else if (elementSelected.stage == 2) {
                    y1.push(element.S1FeedCond);
                  } else if (elementSelected.stage == 3) {
                    y1.push(element.S2FeedCond);
                  } else {
                    y1.push(element.S3FeedCond);
                  }
                  break;
                }
                case 'feed_flow': {
                  if (elementSelected.stage == 1) {
                    y1.push(element.TotalFeedFlow);
                  } else if (elementSelected.stage == 2) {
                    y1.push(element.S1FeedFlow);
                  } else if (elementSelected.stage == 3) {
                    y1.push(element.S2FeedFlow);
                  } else {
                    y1.push(element.S3FeedFlow);
                  }
                  break;
                }
                case 'feed_press': {
                  if (elementSelected.stage == 1) {
                    y1.push(element.S1FeedPress);
                  } else if (elementSelected.stage == 2) {
                    y1.push(element.S1FeedPress);
                  } else if (elementSelected.stage == 3) {
                    y1.push(element.S2FeedPress);
                  } else {
                    y1.push(element.S3FeedPress);
                  }
                  break;
                }
                case 'conc_flow': {
                  if (elementSelected.stage == 1) {
                    y1.push(element.S1ConcFlow);
                  } else if (elementSelected.stage == 2) {
                    y1.push(element.S2ConcFlow);
                  } else if (elementSelected.stage == 3) {
                    y1.push(element.S3ConcFlow);
                  } else {
                    y1.push(element.TotalConcFlow);
                  }
                  break;
                }
                case 'conc_press': {
                  if (elementSelected.stage == 1) {
                    y1.push(element.S1ConcPress);
                  } else if (elementSelected.stage == 2) {
                    y1.push(element.S1ConcPress);
                  } else if (elementSelected.stage == 3) {
                    y1.push(element.S2ConcPress);
                  } else {
                    y1.push(element.S3ConcPress);
                  }
                  break;
                }
                case 'perm_cond': {
                  if (elementSelected.stage == 1) {
                    y1.push(element.TotalPermCond);
                  } else if (elementSelected.stage == 2) {
                    y1.push(element.S1PermCond);
                  } else if (elementSelected.stage == 3) {
                    y1.push(element.S2PermCond);
                  } else {
                    y1.push(element.S3PermCond);
                  }
                  break;
                }
                case 'perm_flow': {
                  if (elementSelected.stage == 1) {
                    y1.push(element.TotalPermFlow);
                  } else if (elementSelected.stage == 2) {
                    y1.push(element.S1PermFlow);
                  } else if (elementSelected.stage == 3) {
                    y1.push(element.S2PermFlow);
                  } else {
                    y1.push(element.S3PermFlow);
                  }
                  break;
                }
                case 'perm_press': {
                  if (elementSelected.stage == 1) {
                    y1.push(element.S1PermPress);
                  } else if (elementSelected.stage == 2) {
                    y1.push(element.S1PermPress);
                  } else if (elementSelected.stage == 3) {
                    y1.push(element.S2PermPress);
                  } else {
                    y1.push(element.S3PermPress);
                  }
                  break;
                }
                case 'recovery': {
                  if (elementSelected.stage == 1) {
                    y1.push(element.TotalRecovery * 100);
                  } else if (elementSelected.stage == 2) {
                    y1.push(element.S1Recovery * 100);
                  } else if (elementSelected.stage == 3) {
                    y1.push(element.S2Recovery * 100);
                  } else {
                    y1.push(element.S3Recovery * 100);
                  }
                  break;
                }
                case 'flux': {
                  if (elementSelected.stage == 1) {
                    y1.push(element.TotalFlux);
                  } else if (elementSelected.stage == 2) {
                    y1.push(element.S1Flux);
                  } else if (elementSelected.stage == 3) {
                    y1.push(element.S2Flux);
                  } else {
                    y1.push(element.S3Flux);
                  }
                  break;
                }
                case 'dp': {
                  if (elementSelected.stage == 1) {
                    y1.push(element.TotalDiffPressure);
                  } else if (elementSelected.stage == 2) {
                    y1.push(element.S1DiffPressure);
                  } else if (elementSelected.stage == 3) {
                    y1.push(element.S2DiffPressure);
                  } else {
                    y1.push(element.S3DiffPressure);
                  }
                  break;
                }
                case 'tmp': {
                  if (elementSelected.stage == 1) {
                    y1.push(element.TotalTmp);
                  } else if (elementSelected.stage == 2) {
                    y1.push(element.S1Tmp);
                  } else if (elementSelected.stage == 3) {
                    y1.push(element.S2Tmp);
                  } else {
                    y1.push(element.S3Tmp);
                  }
                  break;
                }
                case 'net_driv_press': {
                  if (elementSelected.stage == 1) {
                    y1.push(element.TotalNetDrivPress);
                  } else if (elementSelected.stage == 2) {
                    y1.push(element.S1NetDrivPress);
                  } else if (elementSelected.stage == 3) {
                    y1.push(element.S2NetDrivPress);
                  } else {
                    y1.push(element.S3NetDrivPress);
                  }
                  break;
                }
                case 'a_val': {
                  if (elementSelected.stage == 1) {
                    y1.push(element.TotalAVal);
                  } else if (elementSelected.stage == 2) {
                    y1.push(element.S1AVal);
                  } else if (elementSelected.stage == 3) {
                    y1.push(element.S2AVal);
                  } else {
                    y1.push(element.S3AVal);
                  }
                  break;
                }
                case 'b_val': {
                  if (elementSelected.stage == 1) {
                    y1.push(element.TotalBVal);
                  } else if (elementSelected.stage == 2) {
                    y1.push(element.S1BVal);
                  } else if (elementSelected.stage == 3) {
                    y1.push(element.S2BVal);
                  } else {
                    y1.push(element.S3BVal);
                  }
                  break;
                }
                case 'npf': {
                  if (elementSelected.stage == 1) {
                    y1.push(element.TotalNpf);
                  } else if (elementSelected.stage == 2) {
                    y1.push(element.S1Npf);
                  } else if (elementSelected.stage == 3) {
                    y1.push(element.S2Npf);
                  } else {
                    y1.push(element.S3Npf);
                  }
                  break;
                }
                case 'nsp': {
                  if (elementSelected.stage == 1) {
                    y1.push(element.TotalNsp * 100);
                  } else if (elementSelected.stage == 2) {
                    y1.push(element.S1Nsp * 100);
                  } else if (elementSelected.stage == 3) {
                    y1.push(element.S2Nsp * 100);
                  } else {
                    y1.push(element.S3Nsp * 100);
                  }
                  break;
                }
                case 'ud1': {
                  y1.push(element.Ud1);
                  break;
                }
                case 'ud2': {
                  y1.push(element.Ud2);
                  break;
                }
                case 'ud3': {
                  y1.push(element.Ud3);
                  break;
                }
                case 'ud4': {
                  y1.push(element.Ud4);
                  break;
                }
                case 'ud5': {
                  y1.push(element.Ud5);
                  break;
                }
                case 'norm_diff_press': {
                  if (elementSelected.stage == 1) {
                    y1.push(element.TotalNormDiffPress);
                  } else if (elementSelected.stage == 2) {
                    y1.push(element.S1NormDiffPress);
                  } else if (elementSelected.stage == 3) {
                    y1.push(element.S2NormDiffPress);
                  } else {
                    y1.push(element.S3NormDiffPress);
                  }
                  break;
                }
                default: {
                  //statements;
                  break;
                }
              }
            });
          } else if (elementSelected.projectNo == 3) {
            if (elementSelected.showSystemConfig == 'Project3') {
              this.title = elementSelected.trainList.filter(
                (x) => x.value == +elementSelected.trainId
              )[0].sysConfigStr;
            }

            this.opCalData.List3.forEach((element) => {
              x3.push(new Date(element.Datetime));
              switch (this.field1) {
                case 'temp': {
                  y2.push(element.Temp);
                  break;
                }
                case 'ph': {
                  {
                    y2.push(element.Ph);
                  }

                  break;
                }
                case 'feed_cond': {
                  if (elementSelected.stage == 1) {
                    y2.push(element.S1FeedCond);
                  } else if (elementSelected.stage == 2) {
                    y2.push(element.S1FeedCond);
                  } else if (elementSelected.stage == 3) {
                    y2.push(element.S2FeedCond);
                  } else {
                    y2.push(element.S3FeedCond);
                  }
                  break;
                }
                case 'feed_flow': {
                  if (elementSelected.stage == 1) {
                    y2.push(element.TotalFeedFlow);
                  } else if (elementSelected.stage == 2) {
                    y2.push(element.S1FeedFlow);
                  } else if (elementSelected.stage == 3) {
                    y2.push(element.S2FeedFlow);
                  } else {
                    y2.push(element.S3FeedFlow);
                  }
                  break;
                }
                case 'feed_press': {
                  if (elementSelected.stage == 1) {
                    y2.push(element.S1FeedPress);
                  } else if (elementSelected.stage == 2) {
                    y2.push(element.S1FeedPress);
                  } else if (elementSelected.stage == 3) {
                    y2.push(element.S2FeedPress);
                  } else {
                    y2.push(element.S3FeedPress);
                  }
                  break;
                }
                case 'conc_flow': {
                  if (elementSelected.stage == 1) {
                    y2.push(element.TotalConcFlow);
                  } else if (elementSelected.stage == 2) {
                    y2.push(element.S1ConcFlow);
                  } else if (elementSelected.stage == 3) {
                    y2.push(element.S2ConcFlow);
                  } else {
                    y2.push(element.S3ConcFlow);
                  }
                  break;
                }
                case 'conc_press': {
                  if (elementSelected.stage == 1) {
                    y2.push(element.S1ConcPress);
                  } else if (elementSelected.stage == 2) {
                    y2.push(element.S1ConcPress);
                  } else if (elementSelected.stage == 3) {
                    y2.push(element.S2ConcPress);
                  } else {
                    y2.push(element.S3ConcPress);
                  }
                  break;
                }
                case 'perm_cond': {
                  if (elementSelected.stage == 1) {
                    y2.push(element.TotalPermCond);
                  } else if (elementSelected.stage == 2) {
                    y2.push(element.S1PermCond);
                  } else if (elementSelected.stage == 3) {
                    y2.push(element.S2PermCond);
                  } else {
                    y2.push(element.S3PermCond);
                  }
                  break;
                }
                case 'perm_flow': {
                  if (elementSelected.stage == 1) {
                    y2.push(element.TotalPermFlow);
                  } else if (elementSelected.stage == 2) {
                    y2.push(element.S1PermFlow);
                  } else if (elementSelected.stage == 3) {
                    y2.push(element.S2PermFlow);
                  } else {
                    y2.push(element.S3PermFlow);
                  }
                  break;
                }
                case 'perm_press': {
                  if (elementSelected.stage == 1) {
                    y2.push(element.S1PermPress);
                  } else if (elementSelected.stage == 2) {
                    y2.push(element.S1PermPress);
                  } else if (elementSelected.stage == 3) {
                    y2.push(element.S2PermPress);
                  } else {
                    y2.push(element.S3PermPress);
                  }
                  break;
                }
                case 'recovery': {
                  if (elementSelected.stage == 1) {
                    y2.push(element.TotalRecovery * 100);
                  } else if (elementSelected.stage == 2) {
                    y2.push(element.S1Recovery * 100);
                  } else if (elementSelected.stage == 3) {
                    y2.push(element.S2Recovery * 100);
                  } else {
                    y2.push(element.S3Recovery * 100);
                  }
                  break;
                }
                case 'flux': {
                  if (elementSelected.stage == 1) {
                    y2.push(element.TotalFlux);
                  } else if (elementSelected.stage == 2) {
                    y2.push(element.S1Flux);
                  } else if (elementSelected.stage == 3) {
                    y2.push(element.S2Flux);
                  } else {
                    y2.push(element.S3Flux);
                  }
                  break;
                }
                case 'dp': {
                  if (elementSelected.stage == 1) {
                    y2.push(element.TotalDiffPressure);
                  } else if (elementSelected.stage == 2) {
                    y2.push(element.S1DiffPressure);
                  } else if (elementSelected.stage == 3) {
                    y2.push(element.S2DiffPressure);
                  } else {
                    y2.push(element.S3DiffPressure);
                  }
                  break;
                }
                case 'tmp': {
                  if (elementSelected.stage == 1) {
                    y2.push(element.TotalTmp);
                  } else if (elementSelected.stage == 2) {
                    y2.push(element.S1Tmp);
                  } else if (elementSelected.stage == 3) {
                    y2.push(element.S2Tmp);
                  } else {
                    y2.push(element.S3Tmp);
                  }
                  break;
                }
                case 'net_driv_press': {
                  if (elementSelected.stage == 1) {
                    y2.push(element.TotalNetDrivPress);
                  } else if (elementSelected.stage == 2) {
                    y2.push(element.S1NetDrivPress);
                  } else if (elementSelected.stage == 3) {
                    y2.push(element.S2NetDrivPress);
                  } else {
                    y2.push(element.S3NetDrivPress);
                  }
                  break;
                }
                case 'a_val': {
                  if (elementSelected.stage == 1) {
                    y2.push(element.TotalAVal);
                  } else if (elementSelected.stage == 2) {
                    y2.push(element.S1AVal);
                  } else if (elementSelected.stage == 3) {
                    y2.push(element.S2AVal);
                  } else {
                    y2.push(element.S3AVal);
                  }
                  break;
                }
                case 'b_val': {
                  if (elementSelected.stage == 1) {
                    y2.push(element.TotalBVal);
                  } else if (elementSelected.stage == 2) {
                    y2.push(element.S1BVal);
                  } else if (elementSelected.stage == 3) {
                    y2.push(element.S2BVal);
                  } else {
                    y2.push(element.S3BVal);
                  }
                  break;
                }
                case 'npf': {
                  if (elementSelected.stage == 1) {
                    y2.push(element.TotalNpf);
                  } else if (elementSelected.stage == 2) {
                    y2.push(element.S1Npf);
                  } else if (elementSelected.stage == 3) {
                    y2.push(element.S2Npf);
                  } else {
                    y2.push(element.S3Npf);
                  }
                  break;
                }
                case 'nsp': {
                  if (elementSelected.stage == 1) {
                    y2.push(element.TotalNsp * 100);
                  } else if (elementSelected.stage == 2) {
                    y2.push(element.S1Nsp * 100);
                  } else if (elementSelected.stage == 3) {
                    y2.push(element.S2Nsp * 100);
                  } else {
                    y2.push(element.S3Nsp * 100);
                  }
                  break;
                }
                case 'ud1': {
                  y2.push(element.Ud1);
                  break;
                }
                case 'ud2': {
                  y2.push(element.Ud2);
                  break;
                }
                case 'ud3': {
                  y2.push(element.Ud3);
                  break;
                }
                case 'ud4': {
                  y2.push(element.Ud4);
                  break;
                }
                case 'ud5': {
                  y2.push(element.Ud5);
                  break;
                }
                case 'norm_diff_press': {
                  if (elementSelected.stage == 1) {
                    y2.push(element.TotalNormDiffPress);
                  } else if (elementSelected.stage == 2) {
                    y2.push(element.S1NormDiffPress);
                  } else if (elementSelected.stage == 3) {
                    y2.push(element.S2NormDiffPress);
                  } else {
                    y2.push(element.S3NormDiffPress);
                  }
                  break;
                }
                default: {
                  //statements;
                  break;
                }
              }
            });
          } else if (elementSelected.projectNo == 4) {
            if (elementSelected.showSystemConfig == 'Project4') {
              this.title = elementSelected.trainList.filter(
                (x) => x.value == +elementSelected.trainId
              )[0].sysConfigStr;
            }
            //P4
            this.opCalData.List4.forEach((element) => {
              x4.push(new Date(element.Datetime));
              switch (this.field1) {
                case 'temp': {
                  y3.push(element.Temp);
                  break;
                }
                case 'ph': {
                  {
                    y3.push(element.Ph);
                  }

                  break;
                }
                case 'feed_cond': {
                  if (elementSelected.stage == 1) {
                    y3.push(element.S1FeedCond);
                  } else if (elementSelected.stage == 2) {
                    y3.push(element.S1FeedCond);
                  } else if (elementSelected.stage == 3) {
                    y3.push(element.S2FeedCond);
                  } else {
                    y3.push(element.S3FeedCond);
                  }
                  break;
                }
                case 'feed_flow': {
                  if (elementSelected.stage == 1) {
                    y3.push(element.TotalFeedFlow);
                  } else if (elementSelected.stage == 2) {
                    y3.push(element.S1FeedFlow);
                  } else if (elementSelected.stage == 3) {
                    y3.push(element.S2FeedFlow);
                  } else {
                    y3.push(element.S3FeedFlow);
                  }
                  break;
                }
                case 'feed_press': {
                  if (elementSelected.stage == 1) {
                    y3.push(element.S1FeedPress);
                  } else if (elementSelected.stage == 2) {
                    y3.push(element.S1FeedPress);
                  } else if (elementSelected.stage == 3) {
                    y3.push(element.S2FeedPress);
                  } else {
                    y3.push(element.S3FeedPress);
                  }
                  break;
                }
                case 'conc_flow': {
                  if (elementSelected.stage == 1) {
                    y3.push(element.TotalConcFlow);
                  } else if (elementSelected.stage == 2) {
                    y3.push(element.S1ConcFlow);
                  } else if (elementSelected.stage == 3) {
                    y3.push(element.S2ConcFlow);
                  } else {
                    y3.push(element.S3ConcFlow);
                  }
                  break;
                }
                case 'conc_press': {
                  if (elementSelected.stage == 1) {
                    y3.push(element.S1ConcPress);
                  } else if (elementSelected.stage == 2) {
                    y3.push(element.S1ConcPress);
                  } else if (elementSelected.stage == 3) {
                    y3.push(element.S2ConcPress);
                  } else {
                    y3.push(element.S3ConcPress);
                  }
                  break;
                }
                case 'perm_cond': {
                  if (elementSelected.stage == 1) {
                    y3.push(element.TotalPermCond);
                  } else if (elementSelected.stage == 2) {
                    y3.push(element.S1PermCond);
                  } else if (elementSelected.stage == 3) {
                    y3.push(element.S2PermCond);
                  } else {
                    y3.push(element.S3PermCond);
                  }
                  break;
                }
                case 'perm_flow': {
                  if (elementSelected.stage == 1) {
                    y3.push(element.TotalPermFlow);
                  } else if (elementSelected.stage == 2) {
                    y3.push(element.S1PermFlow);
                  } else if (elementSelected.stage == 3) {
                    y3.push(element.S2PermFlow);
                  } else {
                    y3.push(element.S3PermFlow);
                  }
                  break;
                }
                case 'perm_press': {
                  if (elementSelected.stage == 1) {
                    y3.push(element.S1PermPress);
                  } else if (elementSelected.stage == 2) {
                    y3.push(element.S1PermPress);
                  } else if (elementSelected.stage == 3) {
                    y3.push(element.S2PermPress);
                  } else {
                    y3.push(element.S3PermPress);
                  }
                  break;
                }
                case 'recovery': {
                  if (elementSelected.stage == 1) {
                    y3.push(element.TotalRecovery * 100);
                  } else if (elementSelected.stage == 2) {
                    y3.push(element.S1Recovery * 100);
                  } else if (elementSelected.stage == 3) {
                    y3.push(element.S2Recovery * 100);
                  } else {
                    y3.push(element.S3Recovery * 100);
                  }
                  break;
                }
                case 'flux': {
                  if (elementSelected.stage == 1) {
                    y3.push(element.TotalFlux);
                  } else if (elementSelected.stage == 2) {
                    y3.push(element.S1Flux);
                  } else if (elementSelected.stage == 3) {
                    y3.push(element.S2Flux);
                  } else {
                    y3.push(element.S3Flux);
                  }
                  break;
                }
                case 'dp': {
                  if (elementSelected.stage == 1) {
                    y3.push(element.TotalDiffPressure);
                  } else if (elementSelected.stage == 2) {
                    y3.push(element.S1DiffPressure);
                  } else if (elementSelected.stage == 3) {
                    y3.push(element.S2DiffPressure);
                  } else {
                    y3.push(element.S3DiffPressure);
                  }
                  break;
                }
                case 'tmp': {
                  if (elementSelected.stage == 1) {
                    y3.push(element.TotalTmp);
                  } else if (elementSelected.stage == 2) {
                    y3.push(element.S1Tmp);
                  } else if (elementSelected.stage == 3) {
                    y3.push(element.S2Tmp);
                  } else {
                    y3.push(element.S3Tmp);
                  }
                  break;
                }
                case 'ud1': {
                  y3.push(element.Ud1);
                  break;
                }
                case 'ud2': {
                  y3.push(element.Ud2);
                  break;
                }
                case 'ud3': {
                  y3.push(element.Ud3);
                  break;
                }
                case 'ud4': {
                  y3.push(element.Ud4);
                  break;
                }
                case 'ud5': {
                  y3.push(element.Ud5);
                  break;
                }
                case 'net_driv_press': {
                  if (elementSelected.stage == 1) {
                    y3.push(element.TotalNetDrivPress);
                  } else if (elementSelected.stage == 2) {
                    y3.push(element.S1NetDrivPress);
                  } else if (elementSelected.stage == 3) {
                    y3.push(element.S2NetDrivPress);
                  } else {
                    y3.push(element.S3NetDrivPress);
                  }
                  break;
                }
                case 'a_val': {
                  if (elementSelected.stage == 1) {
                    y3.push(element.TotalAVal);
                  } else if (elementSelected.stage == 2) {
                    y3.push(element.S1AVal);
                  } else if (elementSelected.stage == 3) {
                    y3.push(element.S2AVal);
                  } else {
                    y3.push(element.S3AVal);
                  }
                  break;
                }
                case 'b_val': {
                  if (elementSelected.stage == 1) {
                    y3.push(element.TotalBVal);
                  } else if (elementSelected.stage == 2) {
                    y3.push(element.S1BVal);
                  } else if (elementSelected.stage == 3) {
                    y3.push(element.S2BVal);
                  } else {
                    y3.push(element.S3BVal);
                  }
                  break;
                }
                case 'npf': {
                  if (elementSelected.stage == 1) {
                    y3.push(element.TotalNpf);
                  } else if (elementSelected.stage == 2) {
                    y3.push(element.S1Npf);
                  } else if (elementSelected.stage == 3) {
                    y3.push(element.S2Npf);
                  } else {
                    y3.push(element.S3Npf);
                  }
                  break;
                }
                case 'nsp': {
                  if (elementSelected.stage == 1) {
                    y3.push(element.TotalNsp * 100);
                  } else if (elementSelected.stage == 2) {
                    y3.push(element.S1Nsp * 100);
                  } else if (elementSelected.stage == 3) {
                    y3.push(element.S2Nsp* 100);
                  } else {
                    y3.push(element.S3Nsp * 100);
                  }
                  break;
                }
                case 'norm_diff_press': {
                  if (elementSelected.stage == 1) {
                    y3.push(element.TotalNormDiffPress);
                  } else if (elementSelected.stage == 2) {
                    y3.push(element.S1NormDiffPress);
                  } else if (elementSelected.stage == 3) {
                    y3.push(element.S2NormDiffPress);
                  } else {
                    y3.push(element.S3NormDiffPress);
                  }
                  break;
                }
                default: {
                  //statements;
                  break;
                }
              }
            });
            //P4
            this.opCalData.List5.forEach((element) => {
              x5.push(new Date(element.Datetime));
              switch (this.field1) {
                case 'temp': {
                  y4.push(element.Temp);
                  break;
                }
                case 'ph': {
                  {
                    y4.push(element.Ph);
                  }

                  break;
                }
                case 'feed_cond': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.S1FeedCond);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1FeedCond);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2FeedCond);
                  } else {
                    y4.push(element.S3FeedCond);
                  }
                  break;
                }
                case 'feed_flow': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalFeedFlow);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1FeedFlow);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2FeedFlow);
                  } else {
                    y4.push(element.S3FeedFlow);
                  }
                  break;
                }
                case 'feed_press': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.S1FeedPress);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1FeedPress);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2FeedPress);
                  } else {
                    y4.push(element.S3FeedPress);
                  }
                  break;
                }
                case 'conc_flow': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalConcFlow);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1ConcFlow);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2ConcFlow);
                  } else {
                    y4.push(element.S3ConcFlow);
                  }
                  break;
                }
                case 'conc_press': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.S1ConcPress);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1ConcPress);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2ConcPress);
                  } else {
                    y4.push(element.S3ConcPress);
                  }
                  break;
                }
                case 'perm_cond': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalPermCond);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1PermCond);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2PermCond);
                  } else {
                    y4.push(element.S3PermCond);
                  }
                  break;
                }
                case 'perm_flow': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalPermFlow);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1PermFlow);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2PermFlow);
                  } else {
                    y4.push(element.S3PermFlow);
                  }
                  break;
                }
                case 'perm_press': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.S1PermPress);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1PermPress);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2PermPress);
                  } else {
                    y4.push(element.S3PermPress);
                  }
                  break;
                }
                case 'recovery': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalRecovery * 100);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1Recovery * 100);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2Recovery * 100);
                  } else {
                    y4.push(element.S3Recovery);
                  }
                  break;
                }
                case 'flux': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalFlux);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1Flux);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2Flux);
                  } else {
                    y4.push(element.S3Flux);
                  }
                  break;
                }
                case 'dp': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalDiffPressure);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1DiffPressure);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2DiffPressure);
                  } else {
                    y4.push(element.S3DiffPressure);
                  }
                  break;
                }
                case 'tmp': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalTmp);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1Tmp);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2Tmp);
                  } else {
                    y4.push(element.S3Tmp);
                  }
                  break;
                }
                case 'net_driv_press': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalNetDrivPress);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1NetDrivPress);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2NetDrivPress);
                  } else {
                    y4.push(element.S3NetDrivPress);
                  }
                  break;
                }
                case 'a_val': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalAVal);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1AVal);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2AVal);
                  } else {
                    y4.push(element.S3AVal);
                  }
                  break;
                }
                case 'b_val': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalBVal);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1BVal);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2BVal);
                  } else {
                    y4.push(element.S3BVal);
                  }
                  break;
                }
                case 'npf': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalNpf);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1Npf);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2Npf);
                  } else {
                    y4.push(element.S3Npf);
                  }
                  break;
                }
                case 'nsp': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalNsp * 100);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1Nsp * 100);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2Nsp * 100);
                  } else {
                    y4.push(element.S3Nsp * 100);
                  }
                  break;
                }
                case 'ud1': {
                  y4.push(element.Ud1);
                  break;
                }
                case 'ud2': {
                  y4.push(element.Ud2);
                  break;
                }
                case 'ud3': {
                  y4.push(element.Ud3);
                  break;
                }
                case 'ud4': {
                  y4.push(element.Ud4);
                  break;
                }
                case 'ud5': {
                  y4.push(element.Ud5);
                  break;
                }
                case 'norm_diff_press': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalNormDiffPress);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1NormDiffPress);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2NormDiffPress);
                  } else {
                    y4.push(element.S3NormDiffPress);
                  }
                  break;
                }
                default: {
                  //statements;
                  break;
                }
              }
            });
            //P5
          } else if (elementSelected.projectNo == 5) {
            if (elementSelected.showSystemConfig == 'Project5') {
              this.title = elementSelected.trainList.filter(
                (x) => x.value == +elementSelected.trainId
              )[0].sysConfigStr;
            }
            //P5
            this.opCalData.List5.forEach((element) => {
              x.push(new Date(element.Datetime));
              switch (this.field1) {
                case 'temp': {
                  y4.push(element.Temp);
                  break;
                }
                case 'feed_cond': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.S1FeedCond);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1FeedCond);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2FeedCond);
                  } else {
                    y4.push(element.S3FeedCond);
                  }
                  break;
                }
                case 'feed_flow': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalFeedFlow);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1FeedFlow);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2FeedFlow);
                  } else {
                    y4.push(element.S3FeedFlow);
                  }
                  break;
                }
                case 'feed_press': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.S1FeedPress);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1FeedPress);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2FeedPress);
                  } else {
                    y4.push(element.S3FeedPress);
                  }
                  break;
                }
                case 'conc_flow': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalConcFlow);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1ConcFlow);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2ConcFlow);
                  } else {
                    y4.push(element.S3ConcFlow);
                  }
                  break;
                }
                case 'conc_press': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.S1ConcPress);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1ConcPress);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2ConcPress);
                  } else {
                    y4.push(element.S3ConcPress);
                  }
                  break;
                }
                case 'perm_cond': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalPermCond);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1PermCond);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2PermCond);
                  } else {
                    y4.push(element.S3PermCond);
                  }
                  break;
                }
                case 'perm_flow': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalPermFlow);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1PermFlow);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2PermFlow);
                  } else {
                    y4.push(element.S3PermFlow);
                  }
                  break;
                }
                case 'perm_press': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalPermPress);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1PermPress);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2PermPress);
                  } else {
                    y4.push(element.S3PermPress);
                  }
                  break;
                }
                case 'recovery': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalRecovery * 100);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1Recovery * 100);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2Recovery * 100);
                  } else {
                    y4.push(element.S3Recovery * 100);
                  }
                  break;
                }
                case 'flux': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalFlux);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1Flux);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2Flux);
                  } else {
                    y4.push(element.S3Flux);
                  }
                  break;
                }
                case 'dp': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalDiffPressure);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1DiffPressure);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2DiffPressure);
                  } else {
                    y4.push(element.S3DiffPressure);
                  }
                  break;
                }
                case 'tmp': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalTmp);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1Tmp);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2Tmp);
                  } else {
                    y4.push(element.S3Tmp);
                  }
                  break;
                }
                case 'net_driv_press': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalNetDrivPress);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1NetDrivPress);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2NetDrivPress);
                  } else {
                    y4.push(element.S3NetDrivPress);
                  }
                  break;
                }
                case 'a_val': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalAVal);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1AVal);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S3AVal);
                  } else {
                    y4.push(element.S3AVal);
                  }
                  break;
                }
                case 'b_val': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalBVal);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1BVal);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2BVal);
                  } else {
                    y4.push(element.S3BVal);
                  }
                  break;
                }
                case 'npf': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalNpf);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1Npf);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2Npf);
                  } else {
                    y4.push(element.S3Npf);
                  }
                  break;
                }
                case 'nsp': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalNsp * 100);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1Nsp * 100);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2Nsp * 100);
                  } else {
                    y4.push(element.S3Nsp * 100);
                  }
                  break;
                }
                case 'ud1': {
                  y4.push(element.Ud1);
                  break;
                }
                case 'ud2': {
                  y4.push(element.Ud2);
                  break;
                }
                case 'ud3': {
                  y4.push(element.Ud3);
                  break;
                }
                case 'ud4': {
                  y4.push(element.Ud4);
                  break;
                }
                case 'ud5': {
                  y4.push(element.Ud5);
                  break;
                }
                case 'norm_diff_press': {
                  if (elementSelected.stage == 1) {
                    y4.push(element.TotalNormDiffPress);
                  } else if (elementSelected.stage == 2) {
                    y4.push(element.S1NormDiffPress);
                  } else if (elementSelected.stage == 3) {
                    y4.push(element.S2NormDiffPress);
                  } else {
                    y4.push(element.S3NormDiffPress);
                  }
                  break;
                }
                default: {
                  //statements;
                  break;
                }
              }
            });
            //P5
          }
        }
      });

      const getStageLabel = (stageNumber: string | number, plantName: string, trainName: string) => {
        let stageStr = '';
        if (stageNumber == 1) stageStr = 'Total';
        else if (stageNumber == 2) stageStr = 'Stage 1';
        else if (stageNumber == 3) stageStr = 'Stage 2';
        return plantName + ' - ' + trainName + ' - ' + stageStr;
      };
      if (+this.projectNo == 2) {

        const stageLabel1 = getStageLabel(this.project1Stage, this.project1PlantName, this.project1TrainName);
        const stageLabel2 = getStageLabel(this.project2Stage, this.project2PlantName, this.project2TrainName);
        if (this.project1trainUnit == 0) {
          //metric unit
          if (yaxisname == 'Feed Temp') {
            yname = 'P1 ' + yaxisname + '(&deg;C)';
          } else if (yaxisname == 'Concentrate Flow') {
            yname = 'P1 ' + yaxisname + '(m3/hr)';
          } else if (yaxisname == 'Feed Conductivity') {
            yname = 'P1 ' + yaxisname + '(µS/cm)';
          } else if (yaxisname == 'Feed Flow') {
            yname = 'P1 ' + yaxisname + '(m3/hr)';
          } else if (yaxisname == 'Feed Pressure') {
            yname = 'P1 ' + yaxisname + '(bar)';
          } else if (yaxisname == 'Concentrate Flow') {
            yname = 'P1 ' + yaxisname + '(m3/hr)';
          } else if (yaxisname == 'Concentrate Pressure') {
            yname = 'P1 ' + yaxisname + '(bar)';
          } else if (yaxisname == 'Permeate Conductivity') {
            yname = 'P1 ' + yaxisname + '(µS/cm)';
          } else if (yaxisname == 'Permeate Flow') {
            yname = 'P1 ' + yaxisname + '(m3/hr)';
          } else if (yaxisname == 'Permeate Pressure') {
            yname = 'P1 ' + yaxisname + '(bar)';
          } else if (yaxisname == 'Recovery') {
            yname = 'P1 ' + yaxisname + '(%)';
          } else if (yaxisname == 'Flux') {
            yname = 'P1 ' + yaxisname + '(lmh)';
          } else if (yaxisname == 'Flux') {
            yname = 'P1 ' + yaxisname + '(lmh)';
          } else if (yaxisname == 'Differential Pressure') {
            yname = 'P1 ' + +'(bar)';
          } else if (yaxisname == 'TMP') {
            yname = 'P1 ' + yaxisname;
          } else if (yaxisname == 'Net Driving Pressure') {
            yname = 'P1 ' + yaxisname + '(bar)';
          } else if (yaxisname == 'Net Driving Pressure') {
            yname = 'P1 ' + yaxisname + '(bar)';
          } else if (yaxisname == 'A Value') {
            yname = 'P1 ' + yaxisname + '(gfd/psi)';
          } else if (yaxisname == 'B Value') {
            yname = 'P1 ' + yaxisname + '(m/s)';
          } else if (yaxisname == 'Normalized Permeate Flow') {
            yname = 'P1 ' + yaxisname + '(m3/hr)';
          } else if (yaxisname == 'Normalized Salt Passage') {
            yname = 'P1 ' + yaxisname + '(%)';
          } else if (yaxisname == 'User Defined 1') {
            yname = 'P1 ' + yaxisname;
          } else if (yaxisname == 'User Defined 2') {
            yname = 'P1 ' + yaxisname;
          } else if (yaxisname == 'User Defined 3') {
            yname = 'P1 ' + yaxisname;
          } else if (yaxisname == 'User Defined 4') {
            yname = 'P1 ' + yaxisname;
          } else if (yaxisname == 'User Defined 5') {
            yname = 'P1 ' + yaxisname;
          } else if (yaxisname == 'Normalized Differential Pressure') {
            yname = 'P1 ' + yaxisname + '(bar)';
          }
        } //english unit
        else {
          if (yaxisname == 'Feed Temp') {
            yname = 'P1 ' + yaxisname + '(&deg;C)';
          }
          if (yaxisname == 'Concentrate Flow') {
            yname = 'P1 ' + +'(gpm)';
          }
          if (yaxisname == 'Feed Conductivity') {
            yname = 'P1 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Feed Flow') {
            yname = 'P1 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Feed Pressure') {
            yname = 'P1 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Concentrate Flow') {
            yname = 'P1 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Concentrate Pressure') {
            yname = 'P1 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Permeate Conductivity') {
            yname = 'P1 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Permeate Flow') {
            yname = 'P1 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Permeate Pressure') {
            yname = 'P1 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Recovery') {
            yname = 'P1 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'Flux') {
            yname = 'P1 ' + yaxisname + '(gfd)';
          }
          if (yaxisname == 'Differential Pressure') {
            yname = 'P1 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'TMP') {
            yname = 'P1 ' + yaxisname;
          }
          if (yaxisname == 'Net Driving Pressure') {
            yname = 'P1 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'A Value') {
            yname = 'P1 ' + yaxisname + '(gfp/psi)';
          }
          if (yaxisname == 'B Value') {
            yname = 'P1 ' + yaxisname + '(m/s)';
          }
          if (yaxisname == 'Normalized Permeate Flow') {
            yname = 'P1 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Normalized Salt Passage') {
            yname = 'P1 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'User Defined 1') {
            yname = 'P1 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 2') {
            yname = 'P1 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 3') {
            yname = 'P1 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 4') {
            yname = 'P1 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 5') {
            yname = 'P1 ' + yaxisname;
          }
          if (yaxisname == 'Normalized Differential Pressure') {
            yname = 'P1 ' + yaxisname + '(psi)';
          }
        }
        if (this.project2trainUnit == 0) {
          //metric unit
          if (yaxisname == 'Feed Temp') {
            y1name = 'P2 ' + yaxisname + '(&deg;C)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y1name = 'P2 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Feed Conductivity') {
            y1name = 'P2 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Feed Flow') {
            y1name = 'P2 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Feed Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y1name = 'P2 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Concentrate Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Permeate Conductivity') {
            y1name = 'P2 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Permeate Flow') {
            y1name = 'P2 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Permeate Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Recovery') {
            y1name = 'P2 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'Flux') {
            y1name = 'P2 ' + yaxisname + '(lmh)';
          }
          if (yaxisname == 'Flux') {
            y1name = 'P2 ' + yaxisname + '(lmh)';
          }
          if (yaxisname == 'Differential Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'TMP') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'Net Driving Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Net Driving Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'A Value') {
            y1name = 'P2 ' + yaxisname + '(gfd/psi)';
          }
          if (yaxisname == 'B Value') {
            y1name = 'P2 ' + yaxisname + '(m/s)';
          }
          if (yaxisname == 'Normalized Permeate Flow') {
            y1name = 'P2 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Normalized Salt Passage') {
            y1name = 'P2 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'User Defined 1') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 2') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 3') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 4') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 5') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'Normalized Differential Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
        } //english unit
        else {
          if (yaxisname == 'Feed Temp') {
            y1name = 'P2 ' + yaxisname + '(&deg;C)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y1name = 'P2 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Feed Conductivity') {
            y1name = 'P2 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Feed Flow') {
            y1name = 'P2 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Feed Pressure') {
            y1name = 'P2 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y1name = 'P2 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Concentrate Pressure') {
            y1name = 'P2 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Permeate Conductivity') {
            y1name = 'P2 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Permeate Flow') {
            y1name = 'P2 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Permeate Pressure') {
            y1name = 'P2 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Recovery') {
            y1name = 'P2 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'Flux') {
            y1name = 'P2 ' + yaxisname + '(gfd)';
          }
          if (yaxisname == 'Differential Pressure') {
            y1name = 'P2 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'TMP') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'Net Driving Pressure') {
            y1name = 'P2 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'A Value') {
            y1name = 'P2 ' + yaxisname + '(gfp/psi)';
          }
          if (yaxisname == 'B Value') {
            y1name = 'P2 ' + yaxisname + '(m/s)';
          }
          if (yaxisname == 'Normalized Permeate Flow') {
            y1name = 'P2 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Normalized Salt Passage') {
            y1name = 'P2 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'User Defined 1') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 2') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 3') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 4') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 5') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'Normalized Differential Pressure') {
            y1name = 'P2 ' + yaxisname + '(psi)';
          }
        }

        this.plot.plotTwoLineComparisonGraph(
          '',
          'plot',
          x,
          x2,
          y,
          y1,
          yname,
          y1name,
          stageLabel1,
          stageLabel2
        );
      } else if (+this.projectNo == 3) {
        const stageLabel1 = getStageLabel(this.project1Stage, this.project1PlantName, this.project1TrainName);
        const stageLabel2 = getStageLabel(this.project2Stage, this.project2PlantName, this.project2TrainName);
        const stageLabel3 = getStageLabel(this.project3Stage, this.project3PlantName, this.project3TrainName);
        //first y axis
        if (this.project1trainUnit == 0) {
          //metric unit
          if (yaxisname == 'Feed Temp') {
            yname = 'P1 ' + yaxisname + '(&deg;C)';
          } else if (yaxisname == 'Concentrate Flow') {
            yname = 'P1 ' + yaxisname + '(m3/hr)';
          } else if (yaxisname == 'Feed Conductivity') {
            yname = 'P1 ' + yaxisname + '(µS/cm)';
          } else if (yaxisname == 'Feed Flow') {
            yname = 'P1 ' + yaxisname + '(m3/hr)';
          } else if (yaxisname == 'Feed Pressure') {
            yname = 'P1 ' + yaxisname + '(bar)';
          } else if (yaxisname == 'Concentrate Flow') {
            yname = 'P1 ' + yaxisname + '(m3/hr)';
          } else if (yaxisname == 'Concentrate Pressure') {
            yname = 'P1 ' + yaxisname + '(bar)';
          } else if (yaxisname == 'Permeate Conductivity') {
            yname = 'P1 ' + yaxisname + '(µS/cm)';
          } else if (yaxisname == 'Permeate Flow') {
            yname = 'P1 ' + yaxisname + '(m3/hr)';
          } else if (yaxisname == 'Permeate Pressure') {
            yname = 'P1 ' + yaxisname + '(bar)';
          } else if (yaxisname == 'Recovery') {
            yname = 'P1 ' + yaxisname + '(%)';
          } else if (yaxisname == 'Flux') {
            yname = 'P1 ' + yaxisname + '(lmh)';
          } else if (yaxisname == 'Flux') {
            yname = 'P1 ' + yaxisname + '(lmh)';
          } else if (yaxisname == 'Differential Pressure') {
            yname = 'P1 ' + +'(bar)';
          } else if (yaxisname == 'TMP') {
            yname = 'P1 ' + yaxisname;
          } else if (yaxisname == 'Net Driving Pressure') {
            yname = 'P1 ' + yaxisname + '(bar)';
          } else if (yaxisname == 'Net Driving Pressure') {
            yname = 'P1 ' + yaxisname + '(bar)';
          } else if (yaxisname == 'A Value') {
            yname = 'P1 ' + yaxisname + '(gfd/psi)';
          } else if (yaxisname == 'B Value') {
            yname = 'P1 ' + yaxisname + '(m/s)';
          } else if (yaxisname == 'Normalized Permeate Flow') {
            yname = 'P1 ' + yaxisname + '(m3/hr)';
          } else if (yaxisname == 'Normalized Salt Passage') {
            yname = 'P1 ' + yaxisname + '(%)';
          } else if (yaxisname == 'User Defined 1') {
            yname = 'P1 ' + yaxisname;
          } else if (yaxisname == 'User Defined 2') {
            yname = 'P1 ' + yaxisname;
          } else if (yaxisname == 'User Defined 3') {
            yname = 'P1 ' + yaxisname;
          } else if (yaxisname == 'User Defined 4') {
            yname = 'P1 ' + yaxisname;
          } else if (yaxisname == 'User Defined 5') {
            yname = 'P1 ' + yaxisname;
          } else if (yaxisname == 'Normalized Differential Pressure') {
            yname = 'P1 ' + yaxisname + '(bar)';
          }
        } //english unit
        else {
          if (yaxisname == 'Feed Temp') {
            yname = 'P1 ' + yaxisname + '(&deg;C)';
          }
          if (yaxisname == 'Concentrate Flow') {
            yname = 'P1 ' + +'(gpm)';
          }
          if (yaxisname == 'Feed Conductivity') {
            yname = 'P1 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Feed Flow') {
            yname = 'P1 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Feed Pressure') {
            yname = 'P1 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Concentrate Flow') {
            yname = 'P1 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Concentrate Pressure') {
            yname = 'P1 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Permeate Conductivity') {
            yname = 'P1 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Permeate Flow') {
            yname = 'P1 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Permeate Pressure') {
            yname = 'P1 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Recovery') {
            yname = 'P1 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'Flux') {
            yname = 'P1 ' + yaxisname + '(gfd)';
          }
          if (yaxisname == 'Differential Pressure') {
            yname = 'P1 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'TMP') {
            yname = 'P1 ' + yaxisname;
          }
          if (yaxisname == 'Net Driving Pressure') {
            yname = 'P1 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'A Value') {
            yname = 'P1 ' + yaxisname + '(gfp/psi)';
          }
          if (yaxisname == 'B Value') {
            yname = 'P1 ' + yaxisname + '(m/s)';
          }
          if (yaxisname == 'Normalized Permeate Flow') {
            yname = 'P1 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Normalized Salt Passage') {
            yname = 'P1 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'User Defined 1') {
            yname = 'P1 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 2') {
            yname = 'P1 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 3') {
            yname = 'P1 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 4') {
            yname = 'P1 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 5') {
            yname = 'P1 ' + yaxisname;
          }
          if (yaxisname == 'Normalized Differential Pressure') {
            yname = 'P1 ' + yaxisname + '(psi)';
          }
        }
        //second y axis
        if (this.project2trainUnit == 0) {
          //metric unit
          if (yaxisname == 'Feed Temp') {
            y1name = 'P2 ' + yaxisname + '(&deg;C)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y1name = 'P2 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Feed Conductivity') {
            y1name = 'P2 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Feed Flow') {
            y1name = 'P2 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Feed Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y1name = 'P2 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Concentrate Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Permeate Conductivity') {
            y1name = 'P2 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Permeate Flow') {
            y1name = 'P2 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Permeate Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Recovery') {
            y1name = 'P2 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'Flux') {
            y1name = 'P2 ' + yaxisname + '(lmh)';
          }
          if (yaxisname == 'Flux') {
            y1name = 'P2 ' + yaxisname + '(lmh)';
          }
          if (yaxisname == 'Differential Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'TMP') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'Net Driving Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Net Driving Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'A Value') {
            y1name = 'P2 ' + yaxisname + '(gfd/psi)';
          }
          if (yaxisname == 'B Value') {
            y1name = 'P2 ' + yaxisname + '(m/s)';
          }
          if (yaxisname == 'Normalized Permeate Flow') {
            y1name = 'P2 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Normalized Salt Passage') {
            y1name = 'P2 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'User Defined 1') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 2') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 3') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 4') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 5') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'Normalized Differential Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
        } //english unit
        else {
          if (yaxisname == 'Feed Temp') {
            y1name = 'P2 ' + yaxisname + '(&deg;C)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y1name = 'P2 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Feed Conductivity') {
            y1name = 'P2 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Feed Flow') {
            y1name = 'P2 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Feed Pressure') {
            y1name = 'P2 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y1name = 'P2 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Concentrate Pressure') {
            y1name = 'P2 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Permeate Conductivity') {
            y1name = 'P2 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Permeate Flow') {
            y1name = 'P2 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Permeate Pressure') {
            y1name = 'P2 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Recovery') {
            y1name = 'P2 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'Flux') {
            y1name = 'P2 ' + yaxisname + '(gfd)';
          }
          if (yaxisname == 'Differential Pressure') {
            y1name = 'P2 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'TMP') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'Net Driving Pressure') {
            y1name = 'P2 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'A Value') {
            y1name = 'P2 ' + yaxisname + '(gfp/psi)';
          }
          if (yaxisname == 'B Value') {
            y1name = 'P2 ' + yaxisname + '(m/s)';
          }
          if (yaxisname == 'Normalized Permeate Flow') {
            y1name = 'P2 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Normalized Salt Passage') {
            y1name = 'P2 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'User Defined 1') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 2') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 3') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 4') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 5') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'Normalized Differential Pressure') {
            y1name = 'P2 ' + yaxisname + '(psi)';
          }
        }
        //3rd Y axis
        //second y axis
        if (this.project3trainUnit == 0) {
          //metric unit
          if (yaxisname == 'Feed Temp') {
            y2name = 'P3 ' + yaxisname + '(&deg;C)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y2name = 'P3 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Feed Conductivity') {
            y2name = 'P3 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Feed Flow') {
            y2name = 'P3 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Feed Pressure') {
            y2name = 'P3 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y2name = 'P3 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Concentrate Pressure') {
            y2name = 'P3 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Permeate Conductivity') {
            y2name = 'P3' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Permeate Flow') {
            y2name = 'P3 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Permeate Pressure') {
            y2name = 'P3 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Recovery') {
            y2name = 'P3 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'Flux') {
            y2name = 'P3 ' + yaxisname + '(lmh)';
          }
          if (yaxisname == 'Flux') {
            y2name = 'P3 ' + yaxisname + '(lmh)';
          }
          if (yaxisname == 'Differential Pressure') {
            y2name = 'P3 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'TMP') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'Net Driving Pressure') {
            y2name = 'P3 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Net Driving Pressure') {
            y2name = ' ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'A Value') {
            y2name = 'P3 ' + yaxisname + '(gfd/psi)';
          }
          if (yaxisname == 'B Value') {
            y2name = 'P3 ' + yaxisname + '(m/s)';
          }
          if (yaxisname == 'Normalized Permeate Flow') {
            y2name = 'P3 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Normalized Salt Passage') {
            y2name = 'P3 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'User Defined 1') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 2') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 3') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 4') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 5') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'Normalized Differential Pressure') {
            y2name = 'P3 ' + yaxisname + '(bar)';
          }
        } //english unit
        else {
          if (yaxisname == 'Feed Temp') {
            y2name = 'P3 ' + yaxisname + '(&deg;C)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y2name = 'P3 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Feed Conductivity') {
            y2name = 'P3 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Feed Flow') {
            y2name = 'P3 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Feed Pressure') {
            y2name = 'P3' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y2name = 'P3 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Concentrate Pressure') {
            y2name = 'P3 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Permeate Conductivity') {
            y2name = 'P3 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Permeate Flow') {
            y2name = 'P3 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Permeate Pressure') {
            y2name = 'P3 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Recovery') {
            y2name = 'P3 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'Flux') {
            y2name = 'P3 ' + yaxisname + '(gfd)';
          }
          if (yaxisname == 'Differential Pressure') {
            y2name = 'P3 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'TMP') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'Net Driving Pressure') {
            y2name = 'P3 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'A Value') {
            y2name = 'P3 ' + yaxisname + '(gfp/psi)';
          }
          if (yaxisname == 'B Value') {
            y2name = 'P3 ' + yaxisname + '(m/s)';
          }
          if (yaxisname == 'Normalized Permeate Flow') {
            y2name = 'P3 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Normalized Salt Passage') {
            y2name = 'P3 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'User Defined 1') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 2') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 3') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 4') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 5') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'Normalized Differential Pressure') {
            y2name = 'P3 ' + yaxisname + '(psi)';
          }
        }
        this.plot.plotThreeLineComparisonGraph(
          '',
          'plot',
          x,
          x2,
          x3,
          y,
          y1,
          y2,
          yname,
          y1name,
          y2name,
          stageLabel1,
          stageLabel2,
          stageLabel3
        );
      } else if (+this.projectNo == 4) {
        const stageLabel1 = getStageLabel(this.project1Stage, this.project1PlantName, this.project1TrainName);
        const stageLabel2 = getStageLabel(this.project2Stage, this.project2PlantName, this.project2TrainName);
        const stageLabel3 = getStageLabel(this.project3Stage, this.project3PlantName, this.project3TrainName);
        const stageLabel4 = getStageLabel(this.project4Stage, this.project4PlantName, this.project4TrainName);
        //first y axis
        if (this.project1trainUnit == 0) {
          //metric unit
          if (yaxisname == 'Feed Temp') {
            yname = 'P1 ' + yaxisname + '(&deg;C)';
          } else if (yaxisname == 'Concentrate Flow') {
            yname = 'P1 ' + yaxisname + '(m3/hr)';
          } else if (yaxisname == 'Feed Conductivity') {
            yname = 'P1 ' + yaxisname + '(µS/cm)';
          } else if (yaxisname == 'Feed Flow') {
            yname = 'P1 ' + yaxisname + '(m3/hr)';
          } else if (yaxisname == 'Feed Pressure') {
            yname = 'P1 ' + yaxisname + '(bar)';
          } else if (yaxisname == 'Concentrate Flow') {
            yname = 'P1 ' + yaxisname + '(m3/hr)';
          } else if (yaxisname == 'Concentrate Pressure') {
            yname = 'P1 ' + yaxisname + '(bar)';
          } else if (yaxisname == 'Permeate Conductivity') {
            yname = 'P1 ' + yaxisname + '(µS/cm)';
          } else if (yaxisname == 'Permeate Flow') {
            yname = 'P1 ' + yaxisname + '(m3/hr)';
          } else if (yaxisname == 'Permeate Pressure') {
            yname = 'P1 ' + yaxisname + '(bar)';
          } else if (yaxisname == 'Recovery') {
            yname = 'P1 ' + yaxisname + '(%)';
          } else if (yaxisname == 'Flux') {
            yname = 'P1 ' + yaxisname + '(lmh)';
          } else if (yaxisname == 'Flux') {
            yname = 'P1 ' + yaxisname + '(lmh)';
          } else if (yaxisname == 'Differential Pressure') {
            yname = 'P1 ' + +'(bar)';
          } else if (yaxisname == 'TMP') {
            yname = 'P1 ' + yaxisname;
          } else if (yaxisname == 'Net Driving Pressure') {
            yname = 'P1 ' + yaxisname + '(bar)';
          } else if (yaxisname == 'Net Driving Pressure') {
            yname = 'P1 ' + yaxisname + '(bar)';
          } else if (yaxisname == 'A Value') {
            yname = 'P1 ' + yaxisname + '(gfd/psi)';
          } else if (yaxisname == 'B Value') {
            yname = 'P1 ' + yaxisname + '(m/s)';
          } else if (yaxisname == 'Normalized Permeate Flow') {
            yname = 'P1 ' + yaxisname + '(m3/hr)';
          } else if (yaxisname == 'Normalized Salt Passage') {
            yname = 'P1 ' + yaxisname + '(%)';
          } else if (yaxisname == 'User Defined 1') {
            yname = 'P1 ' + yaxisname;
          } else if (yaxisname == 'User Defined 2') {
            yname = 'P1 ' + yaxisname;
          } else if (yaxisname == 'User Defined 3') {
            yname = 'P1 ' + yaxisname;
          } else if (yaxisname == 'User Defined 4') {
            yname = 'P1 ' + yaxisname;
          } else if (yaxisname == 'User Defined 5') {
            yname = 'P1 ' + yaxisname;
          } else if (yaxisname == 'Normalized Differential Pressure') {
            yname = 'P1 ' + yaxisname + '(bar)';
          }
        } //english unit
        else {
          if (yaxisname == 'Feed Temp') {
            yname = 'P1 ' + yaxisname + '(&deg;C)';
          }
          if (yaxisname == 'Concentrate Flow') {
            yname = 'P1 ' + +'(gpm)';
          }
          if (yaxisname == 'Feed Conductivity') {
            yname = 'P1 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Feed Flow') {
            yname = 'P1 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Feed Pressure') {
            yname = 'P1 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Concentrate Flow') {
            yname = 'P1 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Concentrate Pressure') {
            yname = 'P1 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Permeate Conductivity') {
            yname = 'P1 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Permeate Flow') {
            yname = 'P1 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Permeate Pressure') {
            yname = 'P1 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Recovery') {
            yname = 'P1 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'Flux') {
            yname = 'P1 ' + yaxisname + '(gfd)';
          }
          if (yaxisname == 'Differential Pressure') {
            yname = 'P1 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'TMP') {
            yname = 'P1 ' + yaxisname;
          }
          if (yaxisname == 'Net Driving Pressure') {
            yname = 'P1 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'A Value') {
            yname = 'P1 ' + yaxisname + '(gfp/psi)';
          }
          if (yaxisname == 'B Value') {
            yname = 'P1 ' + yaxisname + '(m/s)';
          }
          if (yaxisname == 'Normalized Permeate Flow') {
            yname = 'P1 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Normalized Salt Passage') {
            yname = 'P1 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'User Defined 1') {
            yname = 'P1 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 2') {
            yname = 'P1 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 3') {
            yname = 'P1 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 4') {
            yname = 'P1 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 5') {
            yname = 'P1 ' + yaxisname;
          }
          if (yaxisname == 'Normalized Differential Pressure') {
            yname = 'P1 ' + yaxisname + '(psi)';
          }
        }
        //second y axis
        if (this.project2trainUnit == 0) {
          //metric unit
          if (yaxisname == 'Feed Temp') {
            y1name = 'P2 ' + yaxisname + '(&deg;C)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y1name = 'P2 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Feed Conductivity') {
            y1name = 'P2 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Feed Flow') {
            y1name = 'P2 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Feed Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y1name = 'P2 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Concentrate Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Permeate Conductivity') {
            y1name = 'P2 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Permeate Flow') {
            y1name = 'P2 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Permeate Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Recovery') {
            y1name = 'P2 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'Flux') {
            y1name = 'P2 ' + yaxisname + '(lmh)';
          }
          if (yaxisname == 'Flux') {
            y1name = 'P2 ' + yaxisname + '(lmh)';
          }
          if (yaxisname == 'Differential Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'TMP') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'Net Driving Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Net Driving Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'A Value') {
            y1name = 'P2 ' + yaxisname + '(gfd/psi)';
          }
          if (yaxisname == 'B Value') {
            y1name = 'P2 ' + yaxisname + '(m/s)';
          }
          if (yaxisname == 'Normalized Permeate Flow') {
            y1name = 'P2 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Normalized Salt Passage') {
            y1name = 'P2 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'User Defined 1') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 2') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 3') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 4') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 5') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'Normalized Differential Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
        } //english unit
        else {
          if (yaxisname == 'Feed Temp') {
            y1name = 'P2 ' + yaxisname + '(&deg;C)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y1name = 'P2 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Feed Conductivity') {
            y1name = 'P2 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Feed Flow') {
            y1name = 'P2 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Feed Pressure') {
            y1name = 'P2 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y1name = 'P2 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Concentrate Pressure') {
            y1name = 'P2 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Permeate Conductivity') {
            y1name = 'P2 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Permeate Flow') {
            y1name = 'P2 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Permeate Pressure') {
            y1name = 'P2 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Recovery') {
            y1name = 'P2 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'Flux') {
            y1name = 'P2 ' + yaxisname + '(gfd)';
          }
          if (yaxisname == 'Differential Pressure') {
            y1name = 'P2 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'TMP') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'Net Driving Pressure') {
            y1name = 'P2 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'A Value') {
            y1name = 'P2 ' + yaxisname + '(gfp/psi)';
          }
          if (yaxisname == 'B Value') {
            y1name = 'P2 ' + yaxisname + '(m/s)';
          }
          if (yaxisname == 'Normalized Permeate Flow') {
            y1name = 'P2 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Normalized Salt Passage') {
            y1name = 'P2 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'User Defined 1') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 2') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 3') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 4') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 5') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'Normalized Differential Pressure') {
            y1name = 'P2 ' + yaxisname + '(psi)';
          }
        }
        //3rd Y axis

        if (this.project3trainUnit == 0) {
          //metric unit
          if (yaxisname == 'Feed Temp') {
            y2name = 'P3 ' + yaxisname + '(&deg;C)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y2name = 'P3 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Feed Conductivity') {
            y2name = 'P3 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Feed Flow') {
            y2name = 'P3 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Feed Pressure') {
            y2name = 'P3 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y2name = 'P3 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Concentrate Pressure') {
            y2name = 'P3 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Permeate Conductivity') {
            y2name = 'P3 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Permeate Flow') {
            y2name = 'P3 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Permeate Pressure') {
            y2name = 'P3 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Recovery') {
            y2name = 'P3 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'Flux') {
            y2name = 'P3 ' + yaxisname + '(lmh)';
          }
          if (yaxisname == 'Flux') {
            y2name = 'P3 ' + yaxisname + '(lmh)';
          }
          if (yaxisname == 'Differential Pressure') {
            y2name = 'P3 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'TMP') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'Net Driving Pressure') {
            y2name = 'P3 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Net Driving Pressure') {
            y2name = 'P3 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'A Value') {
            y2name = 'P3 ' + yaxisname + '(gfd/psi)';
          }
          if (yaxisname == 'B Value') {
            y2name = 'P3 ' + yaxisname + '(m/s)';
          }
          if (yaxisname == 'Normalized Permeate Flow') {
            y2name = 'P3 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Normalized Salt Passage') {
            y2name = 'P3 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'User Defined 1') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 2') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 3') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 4') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 5') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'Normalized Differential Pressure') {
            y2name = 'P3 ' + yaxisname + '(bar)';
          }
        } //english unit
        else {
          if (yaxisname == 'Feed Temp') {
            y2name = 'P3 ' + yaxisname + '(&deg;C)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y2name = 'P3 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Feed Conductivity') {
            y2name = 'P3 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Feed Flow') {
            y2name = 'P3 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Feed Pressure') {
            y2name = 'P3 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y2name = 'P3 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Concentrate Pressure') {
            y2name = 'P3' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Permeate Conductivity') {
            y2name = 'P3 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Permeate Flow') {
            y2name = 'P3 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Permeate Pressure') {
            y2name = 'P3 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Recovery') {
            y2name = 'P3 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'Flux') {
            y2name = 'P3 ' + yaxisname + '(gfd)';
          }
          if (yaxisname == 'Differential Pressure') {
            y2name = 'P3 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'TMP') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'Net Driving Pressure') {
            y2name = 'P3 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'A Value') {
            y2name = 'P3 ' + yaxisname + '(gfp/psi)';
          }
          if (yaxisname == 'B Value') {
            y2name = 'P3 ' + yaxisname + '(m/s)';
          }
          if (yaxisname == 'Normalized Permeate Flow') {
            y2name = 'P3 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Normalized Salt Passage') {
            y2name = 'P3 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'User Defined 1') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 2') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 3') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 4') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 5') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'Normalized Differential Pressure') {
            y2name = 'P3 ' + yaxisname + '(psi)';
          }
        }
        //4th Y axis
        if (this.project4trainUnit == 0) {
          //metric unit
          if (yaxisname == 'Feed Temp') {
            y3name = 'P4 ' + yaxisname + '(&deg;C)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y3name = 'P4 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Feed Conductivity') {
            y3name = 'P4 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Feed Flow') {
            y3name = 'P4 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Feed Pressure') {
            y3name = 'P4 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y3name = 'P4 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Concentrate Pressure') {
            y3name = 'P4 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Permeate Conductivity') {
            y3name = 'P4 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Permeate Flow') {
            y3name = 'P4 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Permeate Pressure') {
            y3name = 'P4 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Recovery') {
            y3name = 'P4 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'Flux') {
            y3name = 'P4 ' + yaxisname + '(lmh)';
          }
          if (yaxisname == 'Flux') {
            y3name = 'P4 ' + yaxisname + '(lmh)';
          }
          if (yaxisname == 'Differential Pressure') {
            y3name = 'P4 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'TMP') {
            y3name = 'P4 ' + yaxisname;
          }
          if (yaxisname == 'Net Driving Pressure') {
            y3name = 'P4 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Net Driving Pressure') {
            y3name = 'P4 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'A Value') {
            y3name = 'P4 ' + yaxisname + '(gfd/psi)';
          }
          if (yaxisname == 'B Value') {
            y3name = 'P4 ' + yaxisname + '(m/s)';
          }
          if (yaxisname == 'Normalized Permeate Flow') {
            y3name = 'P4 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Normalized Salt Passage') {
            y3name = 'P4 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'User Defined 1') {
            y3name = 'P4 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 2') {
            y3name = 'P4 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 3') {
            y3name = 'P4 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 4') {
            y3name = 'P4 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 5') {
            y3name = 'P4 ' + yaxisname;
          }
          if (yaxisname == 'Normalized Differential Pressure') {
            y3name = 'P4 ' + yaxisname + '(bar)';
          }
        } //english unit
        else {
          if (yaxisname == 'Feed Temp') {
            y3name = 'P4 ' + yaxisname + '(&deg;C)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y3name = 'P4 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Feed Conductivity') {
            y3name = 'P4 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Feed Flow') {
            y3name = 'P4 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Feed Pressure') {
            y3name = 'P4 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y3name = 'P4 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Concentrate Pressure') {
            y3name = 'P4 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Permeate Conductivity') {
            y3name = 'P4 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Permeate Flow') {
            y3name = 'P4 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Permeate Pressure') {
            y3name = 'P4 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Recovery') {
            y3name = 'P4 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'Flux') {
            y3name = 'P4 ' + yaxisname + '(gfd)';
          }
          if (yaxisname == 'Differential Pressure') {
            y3name = 'P4 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'TMP') {
            y3name = 'P4 ' + yaxisname;
          }
          if (yaxisname == 'Net Driving Pressure') {
            y3name = 'P4 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'A Value') {
            y3name = 'P4 ' + yaxisname + '(gfp/psi)';
          }
          if (yaxisname == 'B Value') {
            y3name = 'P4 ' + yaxisname + '(m/s)';
          }
          if (yaxisname == 'Normalized Permeate Flow') {
            y3name = 'P4 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Normalized Salt Passage') {
            y3name = 'P4 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'User Defined 1') {
            y3name = 'P4 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 2') {
            y3name = 'P4 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 3') {
            y3name = 'P4 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 4') {
            y3name = 'P4 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 5') {
            y3name = 'P4 ' + yaxisname;
          }
          if (yaxisname == 'Normalized Differential Pressure') {
            y3name = 'P4 ' + yaxisname + '(psi)';
          }
        }
        this.plot.plotFourLineComparisonGraph(
          '',
          'plot',
          x,
          x2,
          x3,
          x4,
          y,
          y1,
          y2,
          y3,
          yname,
          y1name,
          y2name,
          y3name,
          stageLabel1,
          stageLabel2,
          stageLabel3,
          stageLabel4
        );
      } else if (+this.projectNo == 5) {
        const stageLabel1 = getStageLabel(this.project1Stage, this.project1PlantName, this.project1TrainName);
        const stageLabel2 = getStageLabel(this.project2Stage, this.project2PlantName, this.project2TrainName);
        const stageLabel3 = getStageLabel(this.project3Stage, this.project3PlantName, this.project3TrainName);
        const stageLabel4 = getStageLabel(this.project4Stage, this.project4PlantName, this.project4TrainName);
        const stageLabel5 = getStageLabel(this.project5Stage, this.project5PlantName, this.project5TrainName);
        //first y axis
        if (this.project1trainUnit == 0) {
          //metric unit
          if (yaxisname == 'Feed Temp') {
            yname = 'P1 ' + yaxisname + '(&deg;C)';
          } else if (yaxisname == 'Concentrate Flow') {
            yname = 'P1 ' + yaxisname + '(m3/hr)';
          } else if (yaxisname == 'Feed Conductivity') {
            yname = 'P1 ' + yaxisname + '(µS/cm)';
          } else if (yaxisname == 'Feed Flow') {
            yname = 'P1 ' + yaxisname + '(m3/hr)';
          } else if (yaxisname == 'Feed Pressure') {
            yname = 'P1 ' + yaxisname + '(bar)';
          } else if (yaxisname == 'Concentrate Flow') {
            yname = 'P1 ' + yaxisname + '(m3/hr)';
          } else if (yaxisname == 'Concentrate Pressure') {
            yname = 'P1 ' + yaxisname + '(bar)';
          } else if (yaxisname == 'Permeate Conductivity') {
            yname = 'P1 ' + yaxisname + '(µS/cm)';
          } else if (yaxisname == 'Permeate Flow') {
            yname = 'P1 ' + yaxisname + '(m3/hr)';
          } else if (yaxisname == 'Permeate Pressure') {
            yname = 'P1 ' + yaxisname + '(bar)';
          } else if (yaxisname == 'Recovery') {
            yname = 'P1 ' + yaxisname + '(%)';
          } else if (yaxisname == 'Flux') {
            yname = 'P1 ' + yaxisname + '(lmh)';
          } else if (yaxisname == 'Flux') {
            yname = 'P1 ' + yaxisname + '(lmh)';
          } else if (yaxisname == 'Differential Pressure') {
            yname = 'P1 ' + +'(bar)';
          } else if (yaxisname == 'TMP') {
            yname = 'P1 ' + yaxisname;
          } else if (yaxisname == 'Net Driving Pressure') {
            yname = 'P1 ' + yaxisname + '(bar)';
          } else if (yaxisname == 'Net Driving Pressure') {
            yname = 'P1 ' + yaxisname + '(bar)';
          } else if (yaxisname == 'A Value') {
            yname = 'P1 ' + yaxisname + '(gfd/psi)';
          } else if (yaxisname == 'B Value') {
            yname = 'P1 ' + yaxisname + '(m/s)';
          } else if (yaxisname == 'Normalized Permeate Flow') {
            yname = 'P1 ' + yaxisname + '(m3/hr)';
          } else if (yaxisname == 'Normalized Salt Passage') {
            yname = 'P1 ' + yaxisname + '(%)';
          } else if (yaxisname == 'User Defined 1') {
            yname = 'P1 ' + yaxisname;
          } else if (yaxisname == 'User Defined 2') {
            yname = 'P1 ' + yaxisname;
          } else if (yaxisname == 'User Defined 3') {
            yname = 'P1 ' + yaxisname;
          } else if (yaxisname == 'User Defined 4') {
            yname = 'P1 ' + yaxisname;
          } else if (yaxisname == 'User Defined 5') {
            yname = 'P1 ' + yaxisname;
          } else if (yaxisname == 'Normalized Differential Pressure') {
            yname = 'P1 ' + yaxisname + '(bar)';
          }
        } //english unit
        else {
          if (yaxisname == 'Feed Temp') {
            yname = 'P1 ' + yaxisname + '(&deg;C)';
          }
          if (yaxisname == 'Concentrate Flow') {
            yname = 'P1 ' + +'(gpm)';
          }
          if (yaxisname == 'Feed Conductivity') {
            yname = 'P1 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Feed Flow') {
            yname = 'P1 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Feed Pressure') {
            yname = 'P1 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Concentrate Flow') {
            yname = 'P1 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Concentrate Pressure') {
            yname = 'P1 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Permeate Conductivity') {
            yname = 'P1 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Permeate Flow') {
            yname = 'P1 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Permeate Pressure') {
            yname = 'P1 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Recovery') {
            yname = 'P1 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'Flux') {
            yname = 'P1 ' + yaxisname + '(gfd)';
          }
          if (yaxisname == 'Differential Pressure') {
            yname = 'P1 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'TMP') {
            yname = 'P1 ' + yaxisname;
          }
          if (yaxisname == 'Net Driving Pressure') {
            yname = 'P1 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'A Value') {
            yname = 'P1 ' + yaxisname + '(gfp/psi)';
          }
          if (yaxisname == 'B Value') {
            yname = 'P1 ' + yaxisname + '(m/s)';
          }
          if (yaxisname == 'Normalized Permeate Flow') {
            yname = 'P1 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Normalized Salt Passage') {
            yname = 'P1 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'User Defined 1') {
            yname = 'P1 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 2') {
            yname = 'P1 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 3') {
            yname = 'P1 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 4') {
            yname = 'P1 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 5') {
            yname = 'P1 ' + yaxisname;
          }
          if (yaxisname == 'Normalized Differential Pressure') {
            yname = 'P1 ' + yaxisname + '(psi)';
          }
        }
        //second y axis
        if (this.project2trainUnit == 0) {
          //metric unit
          if (yaxisname == 'Feed Temp') {
            y1name = 'P2 ' + yaxisname + '(&deg;C)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y1name = 'P2 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Feed Conductivity') {
            y1name = 'P2 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Feed Flow') {
            y1name = 'P2 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Feed Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y1name = 'P2 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Concentrate Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Permeate Conductivity') {
            y1name = 'P2 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Permeate Flow') {
            y1name = 'P2 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Permeate Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Recovery') {
            y1name = 'P2 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'Flux') {
            y1name = 'P2 ' + yaxisname + '(lmh)';
          }
          if (yaxisname == 'Flux') {
            y1name = 'P2 ' + yaxisname + '(lmh)';
          }
          if (yaxisname == 'Differential Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'TMP') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'Net Driving Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Net Driving Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'A Value') {
            y1name = 'P2 ' + yaxisname + '(gfd/psi)';
          }
          if (yaxisname == 'B Value') {
            y1name = 'P2 ' + yaxisname + '(m/s)';
          }
          if (yaxisname == 'Normalized Permeate Flow') {
            y1name = 'P2 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Normalized Salt Passage') {
            y1name = 'P2 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'User Defined 1') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 2') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 3') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 4') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 5') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'Normalized Differential Pressure') {
            y1name = 'P2 ' + yaxisname + '(bar)';
          }
        } //english unit
        else {
          if (yaxisname == 'Feed Temp') {
            y1name = 'P2 ' + yaxisname + '(&deg;C)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y1name = 'P2 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Feed Conductivity') {
            y1name = 'P2 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Feed Flow') {
            y1name = 'P2 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Feed Pressure') {
            y1name = 'P2 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y1name = 'P2 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Concentrate Pressure') {
            y1name = 'P2 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Permeate Conductivity') {
            y1name = 'P2 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Permeate Flow') {
            y1name = 'P2 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Permeate Pressure') {
            y1name = 'P2 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Recovery') {
            y1name = 'P2 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'Flux') {
            y1name = 'P2 ' + yaxisname + '(gfd)';
          }
          if (yaxisname == 'Differential Pressure') {
            y1name = 'P2 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'TMP') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'Net Driving Pressure') {
            y1name = 'P2 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'A Value') {
            y1name = 'P2 ' + yaxisname + '(gfp/psi)';
          }
          if (yaxisname == 'B Value') {
            y1name = 'P2 ' + yaxisname + '(m/s)';
          }
          if (yaxisname == 'Normalized Permeate Flow') {
            y1name = 'P2 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Normalized Salt Passage') {
            y1name = 'P2 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'User Defined 1') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 2') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 3') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 4') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 5') {
            y1name = 'P2 ' + yaxisname;
          }
          if (yaxisname == 'Normalized Differential Pressure') {
            y1name = 'P2 ' + yaxisname + '(psi)';
          }
        }
        //3rd Y axis

        if (this.project3trainUnit == 0) {
          //metric unit
          if (yaxisname == 'Feed Temp') {
            y2name = 'P3 ' + yaxisname + '(&deg;C)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y2name = 'P3 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Feed Conductivity') {
            y2name = 'P3 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Feed Flow') {
            y2name = 'P3 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Feed Pressure') {
            y2name = 'P3 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y2name = 'P3 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Concentrate Pressure') {
            y2name = 'P3 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Permeate Conductivity') {
            y2name = 'P3 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Permeate Flow') {
            y2name = 'P3 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Permeate Pressure') {
            y2name = 'P3 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Recovery') {
            y2name = 'P3 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'Flux') {
            y2name = 'P3 ' + yaxisname + '(lmh)';
          }
          if (yaxisname == 'Flux') {
            y2name = 'P3 ' + yaxisname + '(lmh)';
          }
          if (yaxisname == 'Differential Pressure') {
            y2name = 'P3 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'TMP') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'Net Driving Pressure') {
            y2name = 'P3 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Net Driving Pressure') {
            y2name = 'P3 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'A Value') {
            y2name = 'P3 ' + yaxisname + '(gfd/psi)';
          }
          if (yaxisname == 'B Value') {
            y2name = 'P3 ' + yaxisname + '(m/s)';
          }
          if (yaxisname == 'Normalized Permeate Flow') {
            y2name = 'P3 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Normalized Salt Passage') {
            y2name = 'P3 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'User Defined 1') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 2') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 3') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 4') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 5') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'Normalized Differential Pressure') {
            y2name = 'P3 ' + yaxisname + '(bar)';
          }
        } //english unit
        else {
          if (yaxisname == 'Feed Temp') {
            y2name = 'P3 ' + yaxisname + '(&deg;C)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y2name = 'P3 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Feed Conductivity') {
            y2name = 'P3 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Feed Flow') {
            y2name = 'P3 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Feed Pressure') {
            y2name = 'P3 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y2name = 'P3 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Concentrate Pressure') {
            y2name = 'P3 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Permeate Conductivity') {
            y2name = 'P3 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Permeate Flow') {
            y2name = 'P3 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Permeate Pressure') {
            y2name = 'P3 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Recovery') {
            y2name = 'P3 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'Flux') {
            y2name = 'P3 ' + yaxisname + '(gfd)';
          }
          if (yaxisname == 'Differential Pressure') {
            y2name = 'P3 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'TMP') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'Net Driving Pressure') {
            y2name = 'P3 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'A Value') {
            y2name = 'P3 ' + yaxisname + '(gfp/psi)';
          }
          if (yaxisname == 'B Value') {
            y2name = 'P3 ' + yaxisname + '(m/s)';
          }
          if (yaxisname == 'Normalized Permeate Flow') {
            y2name = 'P3 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Normalized Salt Passage') {
            y2name = 'P3 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'User Defined 1') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 2') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 3') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 4') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 5') {
            y2name = 'P3 ' + yaxisname;
          }
          if (yaxisname == 'Normalized Differential Pressure') {
            y2name = 'P3 ' + yaxisname + '(psi)';
          }
        }
        //4th Y axis
        if (this.project4trainUnit == 0) {
          //metric unit
          if (yaxisname == 'Feed Temp') {
            y3name = 'P4 ' + yaxisname + '(&deg;C)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y3name = 'P4 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Feed Conductivity') {
            y3name = 'P4 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Feed Flow') {
            y3name = 'P4 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Feed Pressure') {
            y3name = 'P4 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y3name = 'P4 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Concentrate Pressure') {
            y3name = 'P4 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Permeate Conductivity') {
            y3name = 'P4 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Permeate Flow') {
            y3name = 'P4 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Permeate Pressure') {
            y3name = 'P4 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Recovery') {
            y3name = 'P4 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'Flux') {
            y3name = 'P4 ' + yaxisname + '(lmh)';
          }
          if (yaxisname == 'Flux') {
            y3name = 'P4' + yaxisname + '(lmh)';
          }
          if (yaxisname == 'Differential Pressure') {
            y3name = 'P4 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'TMP') {
            y3name = 'P4 ' + yaxisname;
          }
          if (yaxisname == 'Net Driving Pressure') {
            y3name = 'P4 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Net Driving Pressure') {
            y3name = 'P4 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'A Value') {
            y3name = 'P4 ' + yaxisname + '(gfd/psi)';
          }
          if (yaxisname == 'B Value') {
            y3name = 'P4 ' + yaxisname + '(m/s)';
          }
          if (yaxisname == 'Normalized Permeate Flow') {
            y3name = 'P4 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Normalized Salt Passage') {
            y3name = 'P4 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'User Defined 1') {
            y3name = 'P4 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 2') {
            y3name = 'P4 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 3') {
            y3name = 'P4 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 4') {
            y3name = 'P4 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 5') {
            y3name = 'P4 ' + yaxisname;
          }
          if (yaxisname == 'Normalized Differential Pressure') {
            y3name = 'P4 ' + yaxisname + '(bar)';
          }
        } //english unit
        else {
          if (yaxisname == 'Feed Temp') {
            y3name = 'P4 ' + yaxisname + '(&deg;C)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y3name = 'P4 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Feed Conductivity') {
            y3name = 'P4 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Feed Flow') {
            y3name = 'P4 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Feed Pressure') {
            y3name = 'P4 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y3name = 'P4 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Concentrate Pressure') {
            y3name = 'P4 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Permeate Conductivity') {
            y3name = 'P4 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Permeate Flow') {
            y3name = 'P4 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Permeate Pressure') {
            y3name = 'P4 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Recovery') {
            y3name = 'P4 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'Flux') {
            y3name = 'P4 ' + yaxisname + '(gfd)';
          }
          if (yaxisname == 'Differential Pressure') {
            y3name = 'P4 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'TMP') {
            y3name = 'P4 ' + yaxisname;
          }
          if (yaxisname == 'Net Driving Pressure') {
            y3name = 'P4 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'A Value') {
            y3name = 'P4 ' + yaxisname + '(gfp/psi)';
          }
          if (yaxisname == 'B Value') {
            y3name = 'P4 ' + yaxisname + '(m/s)';
          }
          if (yaxisname == 'Normalized Permeate Flow') {
            y3name = 'P4 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Normalized Salt Passage') {
            y3name = 'P4 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'User Defined 1') {
            y3name = 'P4 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 2') {
            y3name = 'P4 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 3') {
            y3name = 'P4 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 4') {
            y3name = 'P4 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 5') {
            y3name = 'P4 ' + yaxisname;
          }
          if (yaxisname == 'Normalized Differential Pressure') {
            y3name = 'P4 ' + yaxisname + '(psi)';
          }
        }
        //5th Y axis
        if (this.project5trainUnit == 0) {
          //metric unit
          if (yaxisname == 'Feed Temp') {
            y4name = 'P5 ' + yaxisname + '(&deg;C)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y4name = 'P5 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Feed Conductivity') {
            y4name = 'P5 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Feed Flow') {
            y4name = 'P5 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Feed Pressure') {
            y4name = 'P5 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y4name = 'P5 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Concentrate Pressure') {
            y4name = 'P5 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Permeate Conductivity') {
            y4name = 'P5 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Permeate Flow') {
            y4name = 'P5 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Permeate Pressure') {
            y4name = 'P5 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Recovery') {
            y4name = 'P5 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'Flux') {
            y4name = 'P5 ' + yaxisname + '(lmh)';
          }
          if (yaxisname == 'Flux') {
            y4name = 'P5 ' + yaxisname + '(lmh)';
          }
          if (yaxisname == 'Differential Pressure') {
            y4name = 'P5 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'TMP') {
            y4name = 'P5 ' + yaxisname;
          }
          if (yaxisname == 'Net Driving Pressure') {
            y4name = 'P5 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'Net Driving Pressure') {
            y4name = 'P5 ' + yaxisname + '(bar)';
          }
          if (yaxisname == 'A Value') {
            y4name = 'P5 ' + yaxisname + '(gfd/psi)';
          }
          if (yaxisname == 'B Value') {
            y4name = 'P5 ' + yaxisname + '(m/s)';
          }
          if (yaxisname == 'Normalized Permeate Flow') {
            y4name = 'P5 ' + yaxisname + '(m3/hr)';
          }
          if (yaxisname == 'Normalized Salt Passage') {
            y4name = 'P5 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'User Defined 1') {
            y4name = 'P5 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 2') {
            y4name = 'P5 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 3') {
            y4name = 'P5 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 4') {
            y4name = 'P5 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 5') {
            y4name = 'P5 ' + yaxisname;
          }
          if (yaxisname == 'Normalized Differential Pressure') {
            y4name = 'P5 ' + yaxisname + '(bar)';
          }
        } //english unit
        else {
          if (yaxisname == 'Feed Temp') {
            y4name = 'P5 ' + yaxisname + '(&deg;C)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y4name = 'P5 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Feed Conductivity') {
            y4name = 'P5 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Feed Flow') {
            y4name = 'P5 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Feed Pressure') {
            y4name = 'P5 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Concentrate Flow') {
            y4name = 'P5 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Concentrate Pressure') {
            y4name = 'P5 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Permeate Conductivity') {
            y4name = 'P5 ' + yaxisname + '(µS/cm)';
          }
          if (yaxisname == 'Permeate Flow') {
            y4name = 'P5 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Permeate Pressure') {
            y4name = 'P5 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'Recovery') {
            y4name = 'P5 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'Flux') {
            y4name = 'P5 ' + yaxisname + '(gfd)';
          }
          if (yaxisname == 'Differential Pressure') {
            y4name = 'P5 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'TMP') {
            y4name = 'P5 ' + yaxisname;
          }
          if (yaxisname == 'Net Driving Pressure') {
            y4name = 'P5 ' + yaxisname + '(psi)';
          }
          if (yaxisname == 'A Value') {
            y4name = 'P5 ' + yaxisname + '(gfp/psi)';
          }
          if (yaxisname == 'B Value') {
            y4name = 'P5 ' + yaxisname + '(m/s)';
          }
          if (yaxisname == 'Normalized Permeate Flow') {
            y4name = 'P5 ' + yaxisname + '(gpm)';
          }
          if (yaxisname == 'Normalized Salt Passage') {
            y4name = 'P5 ' + yaxisname + '(%)';
          }
          if (yaxisname == 'User Defined 1') {
            y4name = 'P5 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 2') {
            y4name = 'P5 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 3') {
            y4name = 'P5 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 4') {
            y4name = 'P5 ' + yaxisname;
          }
          if (yaxisname == 'User Defined 5') {
            y4name = 'P5 ' + yaxisname;
          }
          if (yaxisname == 'Normalized Differential Pressure') {
            y4name = 'P5 ' + yaxisname + '(psi)';
          }
        }
        this.plot.plotFiveLineComparisonGraph(
          '',
          'plot',
          x,
          x2,
          x3,
          x4,
          x5,
          y,
          y1,
          y2,
          y3,
          y4,
          yname,
          y1name,
          y2name,
          y3name,
          y4name,
          stageLabel1,
          stageLabel2,
          stageLabel3,
          stageLabel4,
          stageLabel5
        );
      }
    }
  }
}
